import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';
import {Cta} from "../../blocks";
import EstimateLink from "../../components/estimate-link";
import Accordion from "../../components/accordion";
//
import demioDE8_axelasportBM5 from './demio_DE8_axela-sport_BM5.json'; //https://dev2.mazda.co.jp/api/mjo/automotive/cars-comparison?carid=demio&cartypecode=DE8&carid2=axela-sport&cartypecode2=BM5
import axelasedanBM6 from './axela-sedan_BM6.json'; //http://dev2.mazda.co.jp/api/mjo/automotive/cars-comparison?carId=axela-sedan&carTypeCode=BM6
import demioDE7 from './demio_DE7.json'; //https://dev2.mazda.co.jp/api/mjo/automotive/cars-comparison?carid=demio&cartypecode=DE7
import atenzasedanGJ7 from './atenza-sedan_GJ7.json'; //http://dev2.mazda.co.jp/api/mjo/automotive/cars-comparison?carId=atenza-sedan&carTypeCode=GJ7
import {getComponents, getParams, isEqualId, formatId} from "../utilities";
import BodyControl from "../../components/body";
import {IS_MOBILE} from "../../constants/environment";
import {convertKataToRome} from "../../utils";

/**
 *  CarsComparison
 */
class CarsComparison extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    step1Text: PropTypes.string,
    step2Text: PropTypes.string,
    carSelectorDescription: PropTypes.string,
    mbCarSelectorDescription: PropTypes.string,
    carSelectorDescription2: PropTypes.string,
    mbCarSelectorDescription2: PropTypes.string,
    comparisonButtonLabel: PropTypes.string,
    backToCarSelectorText: PropTypes.string,
    specDescription: PropTypes.string,
    mbSpecDescription: PropTypes.string,
    endOfSaleText: PropTypes.string,
    freeArea: PropTypes.array,
    models: PropTypes.arrayOf(PropTypes.shape({
      modelName: PropTypes.string,
      modelNameJa: PropTypes.string,
      bodyTypes: PropTypes.arrayOf(PropTypes.shape({
        carId: PropTypes.string,
        bodyTypeModel: PropTypes.string,
        bodyTypeCategory: PropTypes.string,
        carNavigationNumber: PropTypes.number,
        defaultCarTypeCode: PropTypes.string,
        generations: PropTypes.arrayOf(PropTypes.shape({
          carTypeCode: PropTypes.string,
          minPrice: PropTypes.number,
          releaseDate: PropTypes.string,
          endOfSale: PropTypes.bool,
        })),
      })),
    })),
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    step1Text: null,
    step2Text: null,
    carSelectorDescription: null,
    mbCarSelectorDescription: null,
    carSelectorDescription2: null,
    mbCarSelectorDescription2: null,
    comparisonButtonLabel: null,
    backToCarSelectorText: null,
    specDescription: null,
    mbSpecDescription: null,
    endOfSaleText: null,
    freeArea: null,
    models: null,
  };

  constructor(props) {
    super();
    this.props = props;
    //
    this.state = {
      currentStep: 0,
      isOpened: true,
    };
    //
    this.selectedCarId = null;
    this.selectedCarId2 = null;
    this.selectedCarId3 = null;
    this.selectedCarTypeCode = null;
    this.selectedCarTypeCode2 = null;
    this.selectedCarTypeCode3 = null;
    this.selectedGradeId = null;
    this.selectedGradeId2 = null;
    this.selectedGradeId3 = null;
  }

  componentDidMount() {

    // 初期選択パラメータ
    const params = getParams();
    if (params) {
      const carId = (params.car_id1 && params.car_id1 !== '') ? params.car_id1 : null;
      const carId2 = (params.car_id2 && params.car_id2 !== '') ? params.car_id2 : null;
      const carId3 = (params.car_id3 && params.car_id3 !== '') ? params.car_id3 : null;
      this.selectedCarTypeCode = (params.car_type_code1 && params.car_type_code1 !== '') ? params.car_type_code1 : null;
      this.selectedCarTypeCode2 = (params.car_type_code2 && params.car_type_code2 !== '') ? params.car_type_code2 : null;
      this.selectedCarTypeCode3 = (params.car_type_code3 && params.car_type_code3 !== '') ? params.car_type_code3 : null;
      this.selectedGradeId = (params.grade1 && params.grade1 !== '') ? params.grade1 : null;
      this.selectedGradeId2 = (params.grade2 && params.grade2 !== '') ? params.grade2 : null;
      this.selectedGradeId3 = (params.grade3 && params.grade3 !== '') ? params.grade3 : null;
      if (carId || carId2 || carId3) {
        this.selectCars(carId, carId2, carId3);
      }
    }

    this.setState({
      isMounted: true,
    });
  };

  componentWillUnmount() {
    this.setState({
      isMounted: false,
    });
  }

  render() {

    // ----- Render ----- //

    // ステップ
    const renderStep = () => {
      return (
        <div className="CarsComparison__step">
          <ol className="CarsComparison__step__list">
            <li className={(this.state.currentStep === 0) ? 'current': ''}>
              <span>{(this.props.step1Text && this.props.step1Text !== '') ? this.props.step1Text: ''}</span></li>
            <li className={(this.state.currentStep === 1) ? 'current': ''}>
              <span>{(this.props.step2Text && this.props.step2Text !== '') ? this.props.step2Text: ''}</span></li>
          </ol>
        </div>
      )
    };

    return (
      <Wrapper
        containerId={this.props.containerId}
        containerClass={this.props.containerClass}
        anchorPoint={this.props.anchorPoint}
        anchorName={this.props.anchorName}
      >
        <div className="CarsComparison" ref="main">
          {renderStep()}
          <div className={'CarsComparison__container' + ((this.state.isOpened === true) ? ' open': '')}>
            {(() => {
              if (this.state.isMounted === true) {
                if (this.state.currentStep === 0) {
                  const getModelsInfo = () => {
                    const getMinPrice = (carTypeCode, generations) => {
                      let i, max;
                      for (i = 0, max = generations.length; i < max; i = i + 1) {
                        const generation = generations[i];
                        // if (generation.carTypeCode === carTypeCode) {
                        if (isEqualId(generation.carTypeCode, carTypeCode)) {
                          return generation.minPrice;
                        }
                      }
                    };
                    let info = [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false];
                    let i, max;
                    for (i = 0, max = this.props.models.length; i < max; i = i + 1) {
                      const model = this.props.models[i];
                      let j, max2;
                      for (j = 0, max2 = model.bodyTypes.length; j < max2; j = j + 1) {
                        const bodyType = model.bodyTypes[j];
                        info[bodyType.carNavigationNumber - 1] = {
                          modelName: model.modelName,
                          carId: bodyType.carId,
                          carTypeCode: bodyType.defaultCarTypeCode,
                          model: bodyType.bodyTypeModel,
                          category: bodyType.bodyTypeCategory,
                          price: this.formatPrice(getMinPrice(bodyType.defaultCarTypeCode, bodyType.generations)) + ' 〜（消費税込）',
                          src: this.getBodyTypeImageSrc(model.modelName, bodyType.carId, bodyType.defaultCarTypeCode),
                        }
                      }
                    }
                    return info;
                  };
                  return (
                    <CarSelector
                      {...{
                        description: this.props.carSelectorDescription,
                        mbDescription: this.props.mbCarSelectorDescription,
                        buttonLabel: this.props.comparisonButtonLabel,
                        models: getModelsInfo(),
                        selectCars: (carId, carId2, carId3) => {
                          this.selectCars(carId, carId2, carId3);
                        },
                      }}
                    />
                  )
                } else if (this.state.currentStep === 1) {
                  const getModelsInfo = () => {
                    let info = [];
                    let i, max;
                    for (i = 0, max = this.props.models.length; i < max; i = i + 1) {
                      const model = this.props.models[i];
                      let j, max2;
                      for (j = 0, max2 = model.bodyTypes.length; j < max2; j = j + 1) {
                        const bodyType = model.bodyTypes[j];
                        //
                        info.push({
                          modelName: model.modelName,
                          carId: bodyType.carId,
                          carTypeCode: bodyType.defaultCarTypeCode,
                          bodyTypeModel: bodyType.bodyTypeModel,
                          src: this.getBodyTypeImageSrc(model.modelName, bodyType.carId, bodyType.defaultCarTypeCode),
                          generations: bodyType.generations,
                        })
                      }
                    }
                    return info;
                  };
                  return (
                    <CarComparison
                      {...{
                        description: this.props.carSelectorDescription2,
                        mbDescription: this.props.mbCarSelectorDescription2,
                        backToCarSelectorText: this.props.backToCarSelectorText,
                        specDescription: this.props.specDescription,
                        mbSpecDescription: this.props.mbSpecDescription,
                        freeArea: this.props.freeArea,
                        endOfSaleText: this.props.endOfSaleText,
                        models: getModelsInfo(),
                        selectedCarId: this.selectedCarId,
                        selectedCarId2: this.selectedCarId2,
                        selectedCarId3: this.selectedCarId3,
                        selectedCarTypeCode: this.selectedCarTypeCode,
                        selectedCarTypeCode2: this.selectedCarTypeCode2,
                        selectedCarTypeCode3: this.selectedCarTypeCode3,
                        selectedGradeId: this.selectedGradeId,
                        selectedGradeId2: this.selectedGradeId2,
                        selectedGradeId3: this.selectedGradeId3,
                      }}
                    />
                  )
                } else {
                  return null;
                }
              } else {
                return null;
              }
            })()}
          </div>
        </div>
      </Wrapper>
    );
  }

  // 車種選択
  selectCars = (carId, carId2, carId3) => {
    //console.log('車種選択: ' + carId + ', ' + carId2 + ', ' + carId3);
    this.selectedCarId = carId;
    this.selectedCarId2 = carId2;
    this.selectedCarId3 = carId3;
    // this.setState({
    //   currentStep: 1,
    // });
    this.setState({
      isOpened: false,
    });
    setTimeout(() => {
      this.setState({
        currentStep: 1,
        isOpened: true,
      });
    }, 100);
    //
    BodyControl.scrollToNode(this.refs.main);
  };

  // 金額フォーマット
  formatPrice = (num) => {
    return '¥' + String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  };

  // ボディタイプ画像パス取得
  getBodyTypeImageSrc = (modelName, carId, carTypeCode, size = 's', slanting = false, past = false) => {
    let str = '';
    if (0 <= String(location.hostname).indexOf('localhost')) {
      str = '/assets-dev/assets/cars/';
    } else {
      str = '/globalassets/assets/cars/';
    }
    str = str + modelName + '/';
    str = str + carId + '/';
    str = str + carTypeCode + '/';
    str = str + 'common/';
    if (slanting) {
      if (past) {
        str = str + carId + '_past_chart_' + size + '.png';
      } else {
        str = str + carId + '_chart_' + size + '.png';
      }
    } else {
      str = str + 'default_' + size + '.png';
    }
    str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
    return str;
  };

}

export default CarsComparison;

/**
 *  CarSelector
 */
class CarSelector extends Component {

  static imageCar = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABkCAMAAAD0WI85AAAAdVBMVEUAAACZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZkLL5WPAAAAJnRSTlMAQUjoB8qH4NjUeiyvV080Jg/Q+O6/urRgPcSjaxiolyDbgJ6TdMPCA7gAAAIeSURBVHja7dpnj+IwEAbgwem9906Z//8Tj12J094BqyQ4MKB5PiVSlNGraBzLNjDGGGOMMcYYY4wxxhhjjDHG3oTaBX67PzZuXsfWl1jLimbYt37QqfAewnLILCXBexLFrHtbdEDZ2OYGzmTUR49mmqjMcKHEGvwIaNm5Ka6SanoAVES2iY8wep/CEBAeUnyYUngvzlIV+O3Ns4gaZVJcAa/gayidcQjgd28R45ulhyo8jdBwQ6kR1+5ge9W4caQqwydRJne7LE6Dz+SAXJHjt7p+OrkxPpcHcnRVqQ99Zib4Ii48yin1Q3EO8GLJ+EiGdigMJKJcG8LuTaTEgRWqo4bEKNGK+XiN9JiLY+gKkhTCInaKRPWwQEWuNVb+Ei2kbITZSqQsh9l2SJkCs52QMgNm05EyC2YbkDINZmuQMhdmK5Ay/VN6xIbZbKSs+ZQvEsNse6RMfEgQG+Zrka4YFihfvlhynwfvPmilWmaaUw0LuEiGnuMXJT5UKixX9VSWscDJCt1zVFgtsPPLVr8ZmHiboaEU2r33TLIOXzjCM7CB9nYMXQXhi7OdE4ZhIHa/EOLHdXB+3LncVULzIHDxFh/ksYsRwMRrkwqS+P6dxsxAthGvJB3IZeH/FBWk210VCUEyNcN/GR1sIJjwpzwC+fbblrg4pnhhlrCJsf9bI/ZgM1GbT0qqxI2AzURlU8davqdztoYxxhhjjDG2lT8n6TZcxH8BKgAAAABJRU5ErkJggg==';

  static propTypes = {
    description: PropTypes.string,
    mbDescription: PropTypes.string,
    buttonLabel: PropTypes.string,
    models: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.shape({
          modelName: PropTypes.string,
          carId: PropTypes.string,
          carTypeCode: PropTypes.string,
          model: PropTypes.string,
          category: PropTypes.string,
          price: PropTypes.string,
          src: PropTypes.string,
        }),
      ]),
    ),
    selectCars: PropTypes.func,
  };
  static defaultProps = {
    description: null,
    mbDescription: null,
    buttonLabel: null,
    models: null,
    selectCars: null,
  };

  constructor(props) {
    super();
    this.props = props;
    //
    //this.dropAreaText = '車種を選択';
    this.dropAreaText = '車種を選択してください';
    //
    this.state = {
      selectedCarId: null,
      selectedCarId2: null,
      selectedCarId3: null,
      dropAreaImageSrc: CarSelector.imageCar,
      dropAreaText: this.dropAreaText,
      //dropAreaText: '車種を選択してください',
      dropArea2ImageSrc: CarSelector.imageCar,
      dropArea2Text: this.dropAreaText,
      //dropArea2Text: '車種を選択してください',
      dropArea3ImageSrc: CarSelector.imageCar,
      dropArea3Text: this.dropAreaText,
      //dropArea3Text: '車種を選択してください',
      isMounted: false,
      dropAreaOpened: false,
      dropAreaFixed: false,
      dropAreaHeight: null,
      addAnimationImageSrc: CarSelector.imageCar,
    };
    this.dragTargetRefs = [];
    this.dropAreaRefs = [];
    this.dragTargetSrc = null;
    this.dragTargetText = null;
    this.dropAreaIndex = null;
    //
    this.windowHeight = null;
    this.contentTop = null;
    this.dropAreaTop = null;
    this.intervalId = null;
    this.intervalId2 = null;
    this.pastTarget = null;
  }

  componentDidMount() {
    // ドラッグ&ドロップイベント追加
    const setDragAndDropEvent = () => {
      let i, max;
      for (i = 0, max = this.dragTargetRefs.length; i < max; i = i + 1) {
        const dragTarget = this.refs[this.dragTargetRefs[i]];
        dragTarget.addEventListener('dragstart', (e) => {
          this.selectedCarId = e.target.dataset.carid;
          this.dragTargetSrc = e.target.src;
          this.dragTargetText = e.target.dataset.model;
        }, false);
        dragTarget.addEventListener('drag', (e) => {
          e.target.classList.add('drag');
        }, false);
        dragTarget.addEventListener('dragend', (e) => {
          if (this.dropAreaIndex !== null) {
            if (2 <= this.dropAreaIndex) {
              this.setState({
                selectedCarId3: this.selectedCarId,
                dropArea3ImageSrc: this.dragTargetSrc,
                dropArea3Text: this.dragTargetText,
              });
            } else if (1 <= this.dropAreaIndex) {
              this.setState({
                selectedCarId2: this.selectedCarId,
                dropArea2ImageSrc: this.dragTargetSrc,
                dropArea2Text: this.dragTargetText,
              });
            } else if (0 <= this.dropAreaIndex) {
              this.setState({
                selectedCarId: this.selectedCarId,
                dropAreaImageSrc: this.dragTargetSrc,
                dropAreaText: this.dragTargetText,
              });
            }
          }
          e.target.classList.remove('drag');
          let i, max;
          for (i = 0, max = this.dropAreaRefs.length; i < max; i = i + 1) {
            this.refs[this.dropAreaRefs[i]].classList.remove('drag-enter');
          }
        }, false);
      }
      //
      for (i = 0, max = this.dropAreaRefs.length; i < max; i = i + 1) {
        const dropArea = this.refs[this.dropAreaRefs[i]];
        dropArea.addEventListener('dragenter', (e) => {
          setTimeout(() => {
            this.dropAreaIndex = e.target.dataset.index;
            e.target.classList.add('drag-enter');
          }, 100);
        }, false);
        dropArea.addEventListener('dragleave', (e) => {
          this.dropAreaIndex = null;
          e.target.classList.remove('drag-enter');
        }, false);
        dropArea.addEventListener('dragover', (e) => {
          e.preventDefault();
        }, false);
      }
    };
    setDragAndDropEvent();
    //
    if (IS_MOBILE) {
      this.dropAreaText = '車種を選択';
      this.setState({
        isMounted: true,
        dropAreaText: this.dropAreaText,
        dropArea2Text: this.dropAreaText,
        dropArea3Text: this.dropAreaText,
      });
    } else {
      this.setState({
        isMounted: true,
      });
    }
    //
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    if (this.intervalId) clearTimeout(this.intervalId);
    this.intervalId = setInterval(() => {
      this.handleScroll();
      this.handleResize();
    }, 500);
  };

  componentWillUnmount() {
    this.setState({
      isMounted: false,
    });
    //
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    //
    if (this.intervalId) clearTimeout(this.intervalId);
  }

  render() {

    // ----- Render ----- //

    // 詳細
    const renderDescription = () => {
      const getDescription = () => {
        if (this.props.description && this.props.description !== '') {
          return this.props.description;
        } else {
          return '';
        }
      };
      const getMbDescription = () => {
        if (this.props.mbDescription && this.props.mbDescription !== '') {
          return this.props.mbDescription;
        } else {
          return getDescription();
        }
      };
      return (
        <div className="CarsComparison__car-selector__description">
          <p className="CarsComparison__car-selector__description__paragraph Wysiwyg">
            <span className="CarsComparison__car-selector__description__paragraph-pc"
                  dangerouslySetInnerHTML={{__html: getDescription()}}/>
            <span className="CarsComparison__car-selector__description__paragraph-mb"
                  dangerouslySetInnerHTML={{__html: getMbDescription()}}/>
          </p>
        </div>
      )
    };

    // 車種選択
    const renderBodyTypes = () => {
      this.dragTargetRefs = [];
      return (
        <div className="CarsComparison__car-selector__body-types">
          <ul className="CarsComparison__car-selector__body-types__list">
            {this.props.models.map((bodyTypeInfo, index) => {
              if (bodyTypeInfo) {
                const ref = 'bodyTypeLink' + index;
                this.dragTargetRefs.push(ref);
                return (
                  <li key={index}>
                    <a className="CarsComparison__car-selector__body-types__link"
                       href="javascript:void(0);"
                       data-src={bodyTypeInfo.src}
                       data-model={bodyTypeInfo.model}
                       data-carid={bodyTypeInfo.carId}
                       ref={ref}
                       onDragStart={(e)=> {
                         if (e.target.tagName.toUpperCase() !== 'IMG') {
                           e.preventDefault();
                           return false;
                         }
                       }}
                       onClick={(e) => {
                         e.preventDefault();
                         e.persist();
                         //
                         const target = e.currentTarget;
                         const src = e.currentTarget.dataset.src;
                         const carId = e.currentTarget.dataset.carid;
                         const model = e.currentTarget.dataset.model;
                         if (this.state.selectedCarId === null) {
                           this.startAddAnimation(target, this.refs[this.dropAreaRefs[0]], src, () => {
                             this.setState({
                               selectedCarId: carId,
                               dropAreaImageSrc: src,
                               dropAreaText: model,
                             });
                           });
                         } else if (this.state.selectedCarId2 === null) {
                           this.startAddAnimation(target, this.refs[this.dropAreaRefs[1]], src, () => {
                             this.setState({
                               selectedCarId2: carId,
                               dropArea2ImageSrc: src,
                               dropArea2Text: model,
                             });
                           });
                         } else if (this.state.selectedCarId3 === null) {
                           this.startAddAnimation(target, this.refs[this.dropAreaRefs[2]], src, () => {
                             this.setState({
                               selectedCarId3: carId,
                               dropArea3ImageSrc: src,
                               dropArea3Text: model,
                             });
                           });
                         } else {
                           target.classList.add('attention');
                           setTimeout(()=> {
                            target.classList.remove('attention');
                           }, 1000);
                         }
                       }}
                       draggable="true"
                    >
                      <div style={{position: 'relative'}}>
                        <div className="CarsComparison__car-selector__body-types__box">
                          <div className="CarsComparison__car-selector__body-types__box-inner">
                            <img className="CarsComparison__car-selector__body-types__image"
                                 src={bodyTypeInfo.src}
                                 data-src={bodyTypeInfo.src}
                                 data-model={bodyTypeInfo.model}
                                 data-carid={bodyTypeInfo.carId}
                                 alt=""
                            />
                          </div>
                        </div>
                        <span className="CarsComparison__car-selector__body-types__attention">選択上限を超えています</span>
                      </div>
                      <span className="CarsComparison__car-selector__body-types__name">{bodyTypeInfo.model}</span>
                      <span className="CarsComparison__car-selector__body-types__category">{bodyTypeInfo.category}</span>
                      <span className="CarsComparison__car-selector__body-types__price">{bodyTypeInfo.price}</span>
                    </a>
                  </li>
                )
              } else {
                return (
                  <li className="blank" key={index}></li>
                )
              }
            })}
          </ul>
        </div>
      )
    };

    // ドラックアンドドロップのおき先
    const renderDropTarget = () => {
      const renderDropArea = (src, text) => {
        return (
          <div className="CarsComparison__car-selector__drop-area__box">
            <div className="CarsComparison__car-selector__drop-area__box2">
              <div className="CarsComparison__car-selector__drop-area__box2-inner">
                <img className="CarsComparison__car-selector__drop-area__image" src={src} alt=""/>
              </div>
            </div>
            <p className={'CarsComparison__car-selector__drop-area__paragraph' + ((text !== this.dropAreaText) ? ' selected' : '')}>{text}</p>
          </div>
        )
      };
      const renderLinkClose = (index) => {
        if (index === 0) {
          if (this.state.selectedCarId === null) return;
          return (
            <a className="CarsComparison__car-selector__drop-area__link-close"
               href="javascript:void(0);"
               onClick={(e) => {
                 e.preventDefault();
                 this.setState({
                   selectedCarId: null,
                   dropAreaImageSrc: CarSelector.imageCar,
                   dropAreaText: this.dropAreaText,
                 });
               }}
            >CLOSE</a>
          )
        } else if (index === 1) {
          if (this.state.selectedCarId2 === null) return;
          return (
            <a className="CarsComparison__car-selector__drop-area__link-close"
               href="javascript:void(0);"
               onClick={(e) => {
                 e.preventDefault();
                 this.setState({
                   selectedCarId2: null,
                   dropArea2ImageSrc: CarSelector.imageCar,
                   dropArea2Text: this.dropAreaText,
                 });
               }}
            >CLOSE</a>
          )
        } else if (index === 2) {
          if (this.state.selectedCarId3 === null) return;
          return (
            <a className="CarsComparison__car-selector__drop-area__link-close"
               href="javascript:void(0);"
               onClick={(e) => {
                 e.preventDefault();
                 this.setState({
                   selectedCarId3: null,
                   dropArea3ImageSrc: CarSelector.imageCar,
                   dropArea3Text: this.dropAreaText,
                 });
               }}
            >CLOSE</a>
          )
        }
      };
      const renderCta = () => {
        return (
          <div>
            <form action="get" name="formSelectBodyType">
              <input type="hidden" name="selectedCarId"
                     value={(this.state.selectedCarId) ? this.state.selectedCarId: ''}/>
              <input type="hidden" name="selectedCarId2"
                     value={(this.state.selectedCarId2) ? this.state.selectedCarId2: ''}/>
              <input type="hidden" name="selectedCarId3"
                     value={(this.state.selectedCarId3) ? this.state.selectedCarId3: ''}/>
            </form>
            <Cta
              {...{
                ctaType: 'Free',
                href: null,
                text: this.props.buttonLabel,
                targetBlank: false,
                linkType: 'Button-With-Icon',
                color: 'Dark',
                buttonStyle: 'Standard',
                handleClick: (e) => {
                  e.preventDefault();
                  const carId = (document.forms.formSelectBodyType.selectedCarId.value && document.forms.formSelectBodyType.selectedCarId.value !== '') ? document.forms.formSelectBodyType.selectedCarId.value: null;
                  const carId2 = (document.forms.formSelectBodyType.selectedCarId2.value && document.forms.formSelectBodyType.selectedCarId2.value !== '') ? document.forms.formSelectBodyType.selectedCarId2.value: null;
                  const carId3 = (document.forms.formSelectBodyType.selectedCarId3.value && document.forms.formSelectBodyType.selectedCarId3.value !== '') ? document.forms.formSelectBodyType.selectedCarId3.value: null;
                  if (this.props.selectCars) this.props.selectCars(carId, carId2, carId3);
                },
                iconSrc: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsAQMAAAAkSshCAAAABlBMVEUAAAAICAhtdupNAAAAAXRSTlMAQObYZgAAAEVJREFUGNNjIAEwQijmBjDFfgBCPYAIfoAo+QFR8wdC1UEoewglD9HIT6RGBPUHqgSqAaodbhjCaHuitCEcz9wA9RhJAADuWRclp68w/wAAAABJRU5ErkJggg==',
                hoverIconSrc: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsAQMAAAAkSshCAAAABlBMVEUAAAD19fWydBufAAAAAXRSTlMAQObYZgAAAEVJREFUGNNjIAEwQijmBjDFfgBCPYAIfoAo+QFR8wdC1UEoewglD9HIT6RGBPUHqgSqAaodbhjCaHuitCEcz9wA9RhJAADuWRclp68w/wAAAABJRU5ErkJggg==',
                additionalClass: (this.state.selectedCarId || this.state.selectedCarId2 || this.state.selectedCarId3) ? 'CarsComparison__car-selector__drop-area__link active': 'CarsComparison__car-selector__drop-area__link',
              }}
            />
          </div>
        )
      };
      this.dropAreaRefs = ['dropArea1', 'dropArea2', 'dropArea3'];
      return (
        <div className="CarsComparison__car-selector__drop-area"
             style={(0 <= this.state.dropAreaHeight) ? {height: this.state.dropAreaHeight}: null} ref='dropArea'>
          <div
            className={'CarsComparison__car-selector__drop-area__container' + ((this.state.dropAreaOpened === true) ? ' opened': '') + ((this.state.dropAreaFixed === true) ? ' fixed': '')}
            ref='dropAreaContainer'>
            <div className="CarsComparison__car-selector__drop-area__container2">
              <ul className="CarsComparison__car-selector__drop-area__list">
                <li ref={this.dropAreaRefs[0]} data-index="0">
                  {renderDropArea(this.state.dropAreaImageSrc, this.state.dropAreaText, 0)}
                  {renderLinkClose(0)}
                </li>
                <li ref={this.dropAreaRefs[1]} data-index="1">
                  {renderDropArea(this.state.dropArea2ImageSrc, this.state.dropArea2Text, 1)}
                  {renderLinkClose(1)}
                </li>
                <li ref={this.dropAreaRefs[2]} data-index="2">
                  {renderDropArea(this.state.dropArea3ImageSrc, this.state.dropArea3Text, 2)}
                  {renderLinkClose(2)}
                </li>
                <li>
                  {renderCta()}
                </li>
              </ul>
            </div>
          </div>
        </div>
      )
    };

    return (
      <div className="CarsComparison__car-selector">
        <div className="CarsComparison__car-selector__container">
          {renderDescription()}
        </div>
        <div ref="content">
          <div className="CarsComparison__car-selector__container">
            {renderBodyTypes()}
          </div>
          <div className="CarsComparison__car-selector__container2">
            {renderDropTarget()}
          </div>
        </div>
        <div className="CarsComparison__car-selector__add-animation" ref="addAnimation"><img
          src={this.state.addAnimationImageSrc} alt=""/></div>
      </div>
    );
  }

  // 追加アニメーション開始
  startAddAnimation = (target, target2, src, cb) => {
    const clientRect = target.getBoundingClientRect();
    const startX = clientRect.left;
    const startY = clientRect.top;
    this.refs.addAnimation.style.transform = 'translate(' + startX + 'px, ' + startY + 'px)';
    target.getElementsByTagName('img')[0].classList.add('drag');
    this.setState({
      addAnimationImageSrc: src,
    });
    //
    if (this.pastTarget) this.pastTarget.classList.remove('drag');
    this.pastTarget = target.getElementsByTagName('img')[0];
    this.refs.addAnimation.classList.remove('play');
    if (this.intervalId2) clearTimeout(this.intervalId2);
    this.intervalId2 = setTimeout(() => {
      this.refs.addAnimation.classList.add('play');
      const clientRect = target2.getElementsByTagName('img')[0].getBoundingClientRect();
      // const clientRect = target2.getBoundingClientRect();
      const targetX = clientRect.left;
      const targetY = clientRect.top;
      this.refs.addAnimation.style.transform = 'translate(' + targetX + 'px, ' + targetY + 'px)';
      //
      //if (this.intervalId2) clearTimeout(this.intervalId2);
      this.intervalId2 = setTimeout(() => {
        this.refs.addAnimation.classList.remove('play');
        target.getElementsByTagName('img')[0].classList.remove('drag');
        if (cb) cb();
      }, 750)
    }, 100);
  };

  //
  handleResize = () => {
    const windowTop = window.pageYOffset;
    this.windowHeight = window.innerHeight;
    this.contentTop = this.refs.content.getBoundingClientRect().top + windowTop;
    this.dropAreaTop = this.refs.dropArea.getBoundingClientRect().top + windowTop;
    this.setState({
      dropAreaHeight: this.refs.dropAreaContainer.getBoundingClientRect().height,
    })
  };

  //
  handleScroll = () => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (this.contentTop + 200 <= scrollTop + this.windowHeight) {
      if (this.dropAreaTop + this.state.dropAreaHeight <= scrollTop + this.windowHeight) {
        this.setState({
          dropAreaOpened: true,
          dropAreaFixed: false,
        })
      } else {
        this.setState({
          dropAreaOpened: true,
          dropAreaFixed: true,
        })
      }
    } else {
      this.setState({
        dropAreaOpened: false,
        dropAreaFixed: false,
      })
    }
  };

}

/**
 *  CarComparison
 */
class CarComparison extends Component {
  static propTypes = {
    description: PropTypes.string,
    mbDescription: PropTypes.string,
    backToCarSelectorText: PropTypes.string,
    specDescription: PropTypes.string,
    mbSpecDescription: PropTypes.string,
    endOfSaleText: PropTypes.string,
    freeArea: PropTypes.array,
    models: PropTypes.arrayOf(PropTypes.shape({
      modelName: PropTypes.string,
      carId: PropTypes.string,
      carTypeCode: PropTypes.string,
      bodyTypeModel: PropTypes.string,
      src: PropTypes.string,
      generations: PropTypes.array,
    })),
    selectedCarId: PropTypes.string,
    selectedCarId2: PropTypes.string,
    selectedCarId3: PropTypes.string,
    selectedCarTypeCode: PropTypes.string,
    selectedCarTypeCode2: PropTypes.string,
    selectedCarTypeCode3: PropTypes.string,
    selectedGradeId: PropTypes.string,
    selectedGradeId2: PropTypes.string,
    selectedGradeId3: PropTypes.string,
  };
  static defaultProps = {
    description: null,
    mbDescription: null,
    backToCarSelectorText: null,
    specDescription: null,
    mbSpecDescription: null,
    endOfSaleText: null,
    freeArea: null,
    models: null,
    selectedCarId: null,
    selectedCarId2: null,
    selectedCarId3: null,
    selectedCarTypeCode: null,
    selectedCarTypeCode2: null,
    selectedCarTypeCode3: null,
    selectedGradeId: null,
    selectedGradeId2: null,
    selectedGradeId3: null,
  };

  constructor(props) {
    super();
    this.props = props;
    //
    this.state = {
      isLoading: false,
      isLoading2: false,
      isLoading3: false,
      selectedCarId: this.props.selectedCarId,
      selectedCarId2: this.props.selectedCarId2,
      selectedCarId3: this.props.selectedCarId3,
      selectedCarTypeCode: null,
      selectedCarTypeCode2: null,
      selectedCarTypeCode3: null,
      selectedGradeId: null,
      selectedGradeId2: null,
      selectedGradeId3: null,
      selectedVariantId: null,
      selectedVariantId2: null,
      selectedVariantId3: null,
      //
      isMounted: false,
      fixedNavigationOpened: false,
      subNavigationHeight: null,
      windowWidth: null,
      fixedNavigationBodyTypeHeight: 'auto',
      //
      openLeftCondition: false,
      openCenterCondition: false,
      openRightCondition: false,
    };

    // 初期URLパラメータ
    this.selectedGradeId = this.props.selectedGradeId;
    this.selectedGradeId2 = this.props.selectedGradeId2;
    this.selectedGradeId3 = this.props.selectedGradeId3;

    this.bodyTypeInfo = null;
    this.bodyTypeInfo2 = null;
    this.bodyTypeInfo3 = null;
    //
    this.subNavigationHeight = null;
    this.navigationTop = null;
    this.navigationHeight = null;
    this.specTop = null;
    this.specHeight = null;
    this.intervalId = null;
    this.xhr = new XMLHttpRequest();
  }

  componentDidMount() {
    //
    this.setState({
      isMounted: true,
    });

    // APIアクセス
    let params = [];
    // URLパラメータからAPIのパラメータを取得
    if (this.state.selectedCarId && this.props.selectedCarTypeCode) {
      params.push({
        carId: (this.state.selectedCarId) ? this.state.selectedCarId: null,
        carTypeCode: this.props.selectedCarTypeCode,
      })
    }
    if (this.state.selectedCarId2 && this.props.selectedCarTypeCode2) {
      params.push({
        carId: (this.state.selectedCarId2) ? this.state.selectedCarId2: null,
        carTypeCode: this.props.selectedCarTypeCode2,
      })
    }
    if (this.state.selectedCarId3 && this.props.selectedCarTypeCode3) {
      params.push({
        carId: (this.state.selectedCarId3) ? this.state.selectedCarId3: null,
        carTypeCode: this.props.selectedCarTypeCode3,
      })
    }
    if (1 <= params.length) {
      // URLパラメータで指定されていた場合
      this.accessApi(params);
    } else {
      // URLパラメータの指定がない場合
      this.accessApi([{
        carId: (this.state.selectedCarId) ? this.state.selectedCarId: null,
        carTypeCode: (this.state.selectedCarId) ? this.getModelInfo(this.state.selectedCarId).carTypeCode: null,
      }, {
        carId: (this.state.selectedCarId2) ? this.state.selectedCarId2: null,
        carTypeCode: (this.state.selectedCarId2) ? this.getModelInfo(this.state.selectedCarId2).carTypeCode: null,
      }, {
        carId: (this.state.selectedCarId3) ? this.state.selectedCarId3: null,
        carTypeCode: (this.state.selectedCarId3) ? this.getModelInfo(this.state.selectedCarId3).carTypeCode: null,
      }]);
    }

    //
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
    setTimeout(() => {
      this.handleScroll();
      this.handleResize();
    }, 200);
    //
    if (this.intervalId) clearTimeout(this.intervalId);
    this.intervalId = setInterval(() => {
      this.specHeight = this.refs.spec.getBoundingClientRect().height;
      this.handleScroll();
      this.handleResize();
    }, 500);
  };

  componentWillUnmount() {
    this.setState({
      isMounted: false,
    });
    //
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    //
    if (this.intervalId) clearTimeout(this.intervalId);
  }

  render() {

    // ----- Render ----- //

    // 詳細
    const renderDescription = () => {
      const getDescription = () => {
        if (this.props.description && this.props.description !== '') {
          return this.props.description;
        } else {
          return '';
        }
      };
      const getMbDescription = () => {
        if (this.props.mbDescription && this.props.mbDescription !== '') {
          return this.props.mbDescription;
        } else {
          return getDescription();
        }
      };
      return (
        <div className="CarsComparison__car-comparison__description">
          <p className="CarsComparison__car-comparison__description__paragraph Wysiwyg">
            <span className="CarsComparison__car-comparison__description__paragraph-pc"
                  dangerouslySetInnerHTML={{__html: getDescription()}}/>
            <span className="CarsComparison__car-comparison__description__paragraph-mb"
                  dangerouslySetInnerHTML={{__html: getMbDescription()}}/>
          </p>
        </div>
      )
    };

    // 車種アウトライン
    const renderNavigation = () => {

      // 車種画像
      const renderImage = () => {
        const renderImageItem = (carId) => {
          if (carId) {
            const modelInfo = this.getModelInfo(carId);
            return (
              <img className="CarsComparison__car-comparison__navigation__car-image" src={modelInfo.src}/>
            )
          } else {
            return (
              <img className="CarsComparison__car-comparison__navigation__car-image" src={CarSelector.imageCar}/>
            )
          }
        };
        return (
          <dl className="CarsComparison__car-comparison__navigation__list-dl car-image">
            <dt><span style={{visibility: 'hidden'}}>車種画像</span></dt>
            <dd style={(this.state.openLeftCondition === true) ? {backgroundColor: '#ffffff'}: null}>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderImageItem(this.state.selectedCarId)}
              </div>
            </dd>
            <dd style={(this.state.openCenterCondition === true) ? {backgroundColor: '#ffffff'}: null}>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderImageItem(this.state.selectedCarId2)}
              </div>
            </dd>
            <dd style={(this.state.openRightCondition === true) ? {backgroundColor: '#ffffff'}: null}>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderImageItem(this.state.selectedCarId3)}
              </div>
            </dd>
          </dl>
        )
      };

      // グレード
      const renderGrade2 = () => {
        const renderGradeItem = (bodyTypeInfo, carId, gradeId) => {

          // 100th Anniversary Special Edition > 100周年特別記念車
          const convert100th = (text) => {
            if (text && text !== '') {
              text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '100周年特別記念車 2020 WCDOTY受賞記念モデル');
              text = text.replace('100th Anniversary Special Edition', '100周年特別記念車');
              text = text.replace('100th Anniv Special Edition 2020 WCOTY TOP3 Model', '100周年特別記念車 2020 WCOTY TOP3選出記念モデル');
              text = text.replace('RF 35th SV', '35周年記念車');
              text = text.replace('35th SV', '35周年記念車');
              text = text.replace('XD BD Black', 'XD BD インパネ：グロスブラック');
              text = text.replace('XD BD Light Blue', 'XD BD インパネ：グロスライトブルー');
              text = text.replace('XD BD White', 'XD BD インパネ：ピュアホワイト');
              text = text.replace('15 BD i Selection Black', '15 BD i Selection インパネ：グロスブラック');
              text = text.replace('15 BD i Selection Light Blue', '15 BD i Selection インパネ：グロスライトブルー');
              text = text.replace('15 BD i Selection White', '15 BD i Selection インパネ：ピュアホワイト');
              text = text.replace('15S Leather Touring Selection Black', '15S Leather Touring Selection（ブラックレザーパッケージ）');
              text = text.replace('15S Leather Touring Selection Burgundy', '15S Leather Touring Selection（バーガンディレザーパッケージ）');
              text = text.replace('X Touring Black', 'X Touring(ブラックレザーパッケージ)');
              text = text.replace('X Touring Burgundy', 'X Touring(バーガンディレザーパッケージ)');
              text = text.replace('15 SPORT Plus', '15 SPORT＋');
              text = text.replace('XD SPORT Plus', 'XD SPORT＋');
              return text;
            } else {
              return text;
            }
          };

          if (bodyTypeInfo) {
            const modelInfo = this.getModelInfo(carId);
            let bodyTypeModel = null;
            if (modelInfo) {
              bodyTypeModel = modelInfo.bodyTypeModel;
            }
            const gradeInfo = this.getGradeInfo(bodyTypeInfo, gradeId);
            let specialCar = null;
            let gradeName = null;
            if (gradeInfo) {
              specialCar = gradeInfo.specialCar;
              gradeName = gradeInfo.gradeName;
            }
            let label = gradeName || gradeId;
            if (specialCar === 'true' || specialCar === true) {
              label = gradeId;
            }
            if (label) {
              label = label.replace(/[|]/g, ' ');
            }
            return (
              <div className="CarsComparison__car-comparison__navigation__grade">
                {convert100th(bodyTypeModel)}
                <br />
                {convert100th(label)}
              </div>
            )
          } else {
            return (
              <div className="CarsComparison__car-comparison__navigation__blank"><span>-</span></div>
            );
          }
        };

        return (
          <dl className="CarsComparison__car-comparison__navigation__list-dl grade2">
            <dt>グレード</dt>
            {/*<dd className={(this.state.isLoading === true) ? 'loading' : ''} style={(this.state.openLeftCondition === true) ? {backgroundColor: '#ffffff'} : null}>*/}
            <dd style={(this.state.openLeftCondition === true) ? {backgroundColor: '#ffffff'}: null}>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderGradeItem(this.bodyTypeInfo, this.state.selectedCarId, this.state.selectedGradeId)}
              </div>
            </dd>
            {/*<dd className={(this.state.isLoading2 === true) ? 'loading' : ''} style={(this.state.openCenterCondition === true) ? {backgroundColor: '#ffffff'} : null}>*/}
            <dd style={(this.state.openCenterCondition === true) ? {backgroundColor: '#ffffff'}: null}>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderGradeItem(this.bodyTypeInfo2, this.state.selectedCarId2, this.state.selectedGradeId2)}
              </div>
            </dd>
            {/*<dd className={(this.state.isLoading3 === true) ? 'loading' : ''} style={(this.state.openRightCondition === true) ? {backgroundColor: '#ffffff'} : null}>*/}
            <dd style={(this.state.openRightCondition === true) ? {backgroundColor: '#ffffff'}: null}>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderGradeItem(this.bodyTypeInfo3, this.state.selectedCarId3, this.state.selectedGradeId3)}
              </div>
            </dd>
          </dl>
        )
      };

      // 価格
      const renderPrice2 = () => {
        const renderPriceItem = (carId, carTypeCode, bodyTypeInfo, gradeId, variantId) => {
          if (bodyTypeInfo) {
            const generationInfo = this.getGenerationInfo(carId, carTypeCode);
            if (generationInfo.endOfSale === false) {
              const variantInfo = this.getVariantInfo(bodyTypeInfo, gradeId, variantId);
              return (
                <div className="CarsComparison__car-comparison__navigation__price">
                  {this.formatPrice(variantInfo.price)}
                  <span>〜<br/>（消費税込）</span>
                </div>
              )
            } else {
              return (
                <div className="CarsComparison__car-comparison__navigation__end-of-sale">生産終了</div>
              )
            }
          } else {
            return (
              <div className="CarsComparison__car-comparison__navigation__blank"><span>-</span></div>
            );
          }
        };
        return (
          <dl className="CarsComparison__car-comparison__navigation__list-dl price2">
            <dt>価格</dt>
            {/*<dd className={(this.state.isLoading === true) ? 'loading' : ''} style={(this.state.openLeftCondition === true) ? {backgroundColor: '#ffffff'} : null}>*/}
            <dd style={(this.state.openLeftCondition === true) ? {backgroundColor: '#ffffff'}: null}>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderPriceItem(this.state.selectedCarId, this.state.selectedCarTypeCode, this.bodyTypeInfo, this.state.selectedGradeId, this.state.selectedVariantId)}
              </div>
            </dd>
            {/*<dd className={(this.state.isLoading2 === true) ? 'loading' : ''} style={(this.state.openCenterCondition === true) ? {backgroundColor: '#ffffff'} : null}>*/}
            <dd style={(this.state.openCenterCondition === true) ? {backgroundColor: '#ffffff'}: null}>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderPriceItem(this.state.selectedCarId2, this.state.selectedCarTypeCode2, this.bodyTypeInfo2, this.state.selectedGradeId2, this.state.selectedVariantId2)}
              </div>
            </dd>
            {/*<dd className={(this.state.isLoading3 === true) ? 'loading' : ''} style={(this.state.openRightCondition === true) ? {backgroundColor: '#ffffff'} : null}>*/}
            <dd style={(this.state.openRightCondition === true) ? {backgroundColor: '#ffffff'}: null}>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderPriceItem(this.state.selectedCarId3, this.state.selectedCarTypeCode3, this.bodyTypeInfo3, this.state.selectedGradeId3, this.state.selectedVariantId3)}
              </div>
            </dd>
          </dl>
        )
      };

      // 車種
      const renderBodyType = () => {
        const renderBodyTypeItem = (carId, index) => {
          return (
            <select className="CarsComparison__car-comparison__navigation__select"
                    onChange={(e) => {
                      if (!e.currentTarget.value || e.currentTarget.value === '') {
                        if (index === 0) {
                          this.bodyTypeInfo = null;
                          this.setState({
                            selectedCarId: null,
                            selectedCarTypeCode: null,
                            selectedGradeId: null,
                            selectedVariantId: null,
                          });
                        } else if (index === 1) {
                          this.bodyTypeInfo2 = null;
                          this.setState({
                            selectedCarId2: null,
                            selectedCarTypeCode2: null,
                            selectedGradeId2: null,
                            selectedVariantId2: null,
                          });
                        } else if (index === 2) {
                          this.bodyTypeInfo3 = null;
                          this.setState({
                            selectedCarId3: null,
                            selectedCarTypeCode3: null,
                            selectedGradeId3: null,
                            selectedVariantId3: null,
                          });
                        }
                      } else {
                        const carId = e.currentTarget.value;
                        const carTypeCode = this.getModelInfo(carId).carTypeCode;
                        if (index === 0) {
                          // APIアクセス
                          this.accessApi([{
                            carId: carId,
                            carTypeCode: carTypeCode,
                          }]);
                        } else if (index === 1) {
                          // APIアクセス
                          this.accessApi([null, {
                            carId: carId,
                            carTypeCode: carTypeCode,
                          }]);
                        } else if (index === 2) {
                          // APIアクセス
                          this.accessApi([null, null, {
                            carId: carId,
                            carTypeCode: carTypeCode,
                          }]);
                        }

                        // GTMイベント
                        BodyControl.setGTMEvent({
                          trackcartype: this.getModelInfo(carId).bodyTypeModel,
                          event: 'CarsComparisonSelect'
                        });

                      }
                    }}
                    defaultValue={carId}
            >
              <option value="">車種を選択してください</option>
              {this.props.models.map((model, index) => {
                return (
                  <option key={index} value={model.carId} selected={isEqualId(carId, model.carId) ? true : false}>
                    {model.bodyTypeModel}
                  </option>
                )
              })}
            </select>
          )
        };
        return (
          <dl className="CarsComparison__car-comparison__navigation__list-dl">
            <dt>車種</dt>
            {/*<dd className={(this.state.isLoading === true) ? 'loading' : ''}>*/}
            <dd>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderBodyTypeItem(this.state.selectedCarId, 0)}
              </div>
            </dd>
            {/*<dd className={(this.state.isLoading2 === true) ? 'loading' : ''}>*/}
            <dd>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderBodyTypeItem(this.state.selectedCarId2, 1)}
              </div>
            </dd>
            {/*<dd className={(this.state.isLoading3 === true) ? 'loading' : ''}>*/}
            <dd>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderBodyTypeItem(this.state.selectedCarId3, 2)}
              </div>
            </dd>
          </dl>
        )
      };

      // 発売年月
      const renderReleaseDate = () => {
        const renderReleaseDateItem = (carId, carTypeCode, index) => {
          if (carId) {
            const modelInfo = this.getModelInfo(carId);
            return (
              <select className="CarsComparison__car-comparison__navigation__select"
                      onChange={(e) => {
                        const carId = carId;
                        const carTypeCode = e.currentTarget.value;
                        if (index === 0) {
                          // APIアクセス
                          this.accessApi([{
                            carId: this.state.selectedCarId,
                            carTypeCode: carTypeCode,
                          }]);
                        } else if (index === 1) {
                          // APIアクセス
                          this.accessApi([null, {
                            carId: this.state.selectedCarId2,
                            carTypeCode: carTypeCode,
                          }]);
                        } else if (index === 2) {
                          // APIアクセス
                          this.accessApi([null, null, {
                            carId: this.state.selectedCarId3,
                            carTypeCode: carTypeCode,
                          }]);
                        }
                      }}
                      defaultValue={modelInfo.carTypeCode}
              >
                {modelInfo.generations.map((generation, index) => {
                  if (generation.endOfSale === true) {
                    return (
                      <option key={index} value={generation.carTypeCode} selected={isEqualId(generation.carTypeCode, carTypeCode) ? true : false}>
                        {this.formatReleaseDate(generation.releaseDate) + '('  + this.props.endOfSaleText + ')'}
                      </option>
                    )
                  } else {
                    return (
                      <option key={index} value={generation.carTypeCode} selected={isEqualId(generation.carTypeCode, carTypeCode) ? true : false}>
                        {this.formatReleaseDate(generation.releaseDate)}
                      </option>
                    )
                  }
                })}
              </select>
            )
          } else {
            return (
              <div className="CarsComparison__car-comparison__navigation__blank"><span>-</span></div>
            );
          }
        };
        return (
          <dl className="CarsComparison__car-comparison__navigation__list-dl">
            <dt>発表・発売年月</dt>
            {/*<dd className={(this.state.isLoading === true) ? 'loading' : ''}>*/}
            <dd>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderReleaseDateItem(this.state.selectedCarId, this.state.selectedCarTypeCode, 0)}
              </div>
            </dd>
            {/*<dd className={(this.state.isLoading2 === true) ? 'loading' : ''}>*/}
            <dd>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderReleaseDateItem(this.state.selectedCarId2, this.state.selectedCarTypeCode2, 1)}
              </div>
            </dd>
            {/*<dd className={(this.state.isLoading3 === true) ? 'loading' : ''}>*/}
            <dd>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderReleaseDateItem(this.state.selectedCarId3, this.state.selectedCarTypeCode3, 2)}
              </div>
            </dd>
          </dl>
        )
      };

      // グレード
      const renderGrade = () => {
        const renderGradeItem = (bodyTypeInfo, gradeId, index) => {

          // 100th Anniversary Special Edition > 100周年特別記念車
          const convert100th = (text) => {
            if (text && text !== '') {
              text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '100周年特別記念車 2020 WCDOTY受賞記念モデル');
              text = text.replace('100th Anniversary Special Edition', '100周年特別記念車');
              text = text.replace('100th Anniv Special Edition 2020 WCOTY TOP3 Model', '100周年特別記念車 2020 WCOTY TOP3選出記念モデル');
              text = text.replace('RF 35th SV', '35周年記念車');
              text = text.replace('35th SV', '35周年記念車');
              text = text.replace('XD BD Black', 'XD BD インパネ：グロスブラック');
              text = text.replace('XD BD Light Blue', 'XD BD インパネ：グロスライトブルー');
              text = text.replace('XD BD White', 'XD BD インパネ：ピュアホワイト');
              text = text.replace('15 BD i Selection Black', '15 BD i Selection インパネ：グロスブラック');
              text = text.replace('15 BD i Selection Light Blue', '15 BD i Selection インパネ：グロスライトブルー');
              text = text.replace('15 BD i Selection White', '15 BD i Selection インパネ：ピュアホワイト');
              text = text.replace('15S Leather Touring Selection Black', '15S Leather Touring Selection（ブラックレザーパッケージ）');
              text = text.replace('15S Leather Touring Selection Burgundy', '15S Leather Touring Selection（バーガンディレザーパッケージ）');
              text = text.replace('X Touring Black', 'X Touring(ブラックレザーパッケージ)');
              text = text.replace('X Touring Burgundy', 'X Touring(バーガンディレザーパッケージ)');
              text = text.replace('15 SPORT Plus', '15 SPORT＋');
              text = text.replace('XD SPORT Plus', 'XD SPORT＋');
              return text;
            } else {
              return text;
            }
          };

          if (gradeId) {
            return (
              <select className="CarsComparison__car-comparison__navigation__select"
                      onChange={(e) => {
                        // グレード変更
                        this.changeGrade(e.currentTarget.value, index);
                      }}
                      defaultValue={gradeId}
              >
                {this.getGradesInfo(bodyTypeInfo).map((grade, index) => {
                  let label = grade.gradeName;
                  if (grade.specialCar === 'true' || grade.specialCar === true) {
                    label = grade.gradeId;
                  } else {
                    if (!label || label === '') {
                      label = grade.gradeId;
                    }
                  }
                  label = label.replace(/[|]/g, ' ');
                  return (
                    <option key={index} value={grade.gradeId} selected={isEqualId(grade.gradeId, gradeId) ? true : false}>
                      {convert100th(label)}
                      {/*{label}*/}
                    </option>
                  )
                })}
              </select>
            )
          } else {
            return (
              <div className="CarsComparison__car-comparison__navigation__blank"><span>-</span></div>
            );
          }
        };
        return (
          <dl className="CarsComparison__car-comparison__navigation__list-dl">
            <dt>グレード</dt>
            {/*<dd className={(this.state.isLoading === true) ? 'loading' : ''}>*/}
            <dd>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderGradeItem(this.bodyTypeInfo, this.state.selectedGradeId, 0)}
              </div>
            </dd>
            {/*<dd className={(this.state.isLoading2 === true) ? 'loading' : ''}>*/}
            <dd>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderGradeItem(this.bodyTypeInfo2, this.state.selectedGradeId2, 1)}
              </div>
            </dd>
            {/*<dd className={(this.state.isLoading3 === true) ? 'loading' : ''}>*/}
            <dd>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderGradeItem(this.bodyTypeInfo3, this.state.selectedGradeId3, 2)}
              </div>
            </dd>
          </dl>
        )
      };

      // 機種
      const renderVariant = () => {
        const renderVariantItem = (bodyTypeInfo, gradeId, variantId, index) => {
          if (bodyTypeInfo) {
            let variantsInfo = this.getVariantsInfo(bodyTypeInfo, gradeId);
            return (
              <select className="CarsComparison__car-comparison__navigation__select"
                      onChange={(e) => {
                        // 機種変更
                        this.changeVariant(e.currentTarget.value, index);
                      }}
                      defaultValue={variantId}
              >
                {variantsInfo.map((variant, index2) => {
                  return (
                    <option key={index2} value={variant.variantId} selected={(variant.variantId === variantId) ? true : false}>
                      {variant.drive + ' / ' + variant.transmission}
                    </option>
                  )
                })}
              </select>
            )
          } else {
            return (
              <div className="CarsComparison__car-comparison__navigation__blank"><span>-</span></div>
            );
          }
        };
        return (
          <dl className="CarsComparison__car-comparison__navigation__list-dl">
            <dt>駆動/ミッション</dt>
            {/*<dd className={(this.state.isLoading === true) ? 'loading' : ''}>*/}
            <dd>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderVariantItem(this.bodyTypeInfo, this.state.selectedGradeId, this.state.selectedVariantId, 0)}
              </div>
            </dd>
            {/*<dd className={(this.state.isLoading2 === true) ? 'loading' : ''}>*/}
            <dd>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderVariantItem(this.bodyTypeInfo2, this.state.selectedGradeId2, this.state.selectedVariantId2, 1)}
              </div>
            </dd>
            {/*<dd className={(this.state.isLoading3 === true) ? 'loading' : ''}>*/}
            <dd>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderVariantItem(this.bodyTypeInfo3, this.state.selectedGradeId3, this.state.selectedVariantId3, 2)}
              </div>
            </dd>
          </dl>
        )
      };

      // 価格
      const renderPrice = () => {
        const renderPriceItem = (carId, carTypeCode, bodyTypeInfo, gradeId, variantId) => {
          if (bodyTypeInfo) {
            const generationInfo = this.getGenerationInfo(carId, carTypeCode);
            if (generationInfo.endOfSale === false) {
              const variantInfo = this.getVariantInfo(bodyTypeInfo, gradeId, variantId);
              return (
                <div className="CarsComparison__car-comparison__navigation__price">
                  {this.formatPrice(variantInfo.price)}
                  <span>〜<br/>（消費税込）</span>
                </div>
              )
            } else {
              return (
                <div className="CarsComparison__car-comparison__navigation__end-of-sale">生産終了</div>
              )
            }
          } else {
            return (
              <div className="CarsComparison__car-comparison__navigation__blank"><span>-</span></div>
            );
          }
        };
        return (
          <dl className="CarsComparison__car-comparison__navigation__list-dl price">
            <dt>価格</dt>
            {/*<dd className={(this.state.isLoading === true) ? 'loading' : ''}>*/}
            <dd>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderPriceItem(this.state.selectedCarId, this.state.selectedCarTypeCode, this.bodyTypeInfo, this.state.selectedGradeId, this.state.selectedVariantId)}
              </div>
            </dd>
            {/*<dd className={(this.state.isLoading2 === true) ? 'loading' : ''}>*/}
            <dd>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderPriceItem(this.state.selectedCarId2, this.state.selectedCarTypeCode2, this.bodyTypeInfo2, this.state.selectedGradeId2, this.state.selectedVariantId2)}
              </div>
            </dd>
            {/*<dd className={(this.state.isLoading3 === true) ? 'loading' : ''}>*/}
            <dd>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderPriceItem(this.state.selectedCarId3, this.state.selectedCarTypeCode3, this.bodyTypeInfo3, this.state.selectedGradeId3, this.state.selectedVariantId3)}
              </div>
            </dd>
          </dl>
        )
      };

      // エコカー
      const renderTaxInfo = () => {
        const renderTaxInfoItem = (carId, carTypeCode, bodyTypeInfo, gradeId, variantId) => {
          if (bodyTypeInfo) {
            const generationInfo = this.getGenerationInfo(carId, carTypeCode);
            if (generationInfo.endOfSale === false) {
              // const gradeInfo = this.getGradeInfo(bodyTypeInfo, gradeId);
              const variantInfo = this.getVariantInfo(bodyTypeInfo, gradeId, variantId);
              const renderKankyowari = () => {
                if (variantInfo) {
                  if (variantInfo.kankyowari === true || variantInfo.kankyowari === 'true') {
                    return (
                      <li className="CarsComparison__car-comparison__navigation__tax-item">
                        <span>
                          {'環境性能割 '}
                          <br/>
                          {'非課税'}
                        </span>
                      </li>
                    )
                  // } else if (variantInfo.kankyowari === false || variantInfo.kankyowari === 'false') {
                  //   return (
                  //     <li className="CarsComparison__car-comparison__navigation__tax-item">
                  //       <span>
                  //         {'環境性能割 '}
                  //         <br/>
                  //         {'課税対象'}
                  //       </span>
                  //     </li>
                  //   )
                  } else {
                    return null;
                  }
                } else {
                  return null;
                }
              };
              const renderSubsidy = () => {
                if (variantInfo) {
                  if (variantInfo.subsidy === true || variantInfo.subsidy === 'true') {
                    return (
                      <li className="CarsComparison__car-comparison__navigation__tax-item">
                        {/*<span>*/}
                        {/*  {'クリーンディーゼル'}*/}
                        {/*  <br/>*/}
                        {/*  {'補助金'}*/}
                        {/*</span>*/}
                        <span>
                          {'CEV補助金'}
                        </span>
                      </li>
                    )
                  } else {
                    return null;
                  }
                } else {
                  return null;
                }
              };
              const renderTax = () => {
                if (variantInfo) {
                  const weightTaxRate = Number(variantInfo.taxInfo.weightTaxRate);
                  if (100 <= weightTaxRate) {
                    return (
                      <li className="CarsComparison__car-comparison__navigation__tax-item">
                        <span>
                          {'重量税 '}
                          <br/>
                          {'免税'}
                        </span>
                      </li>
                    )
                  } else if (1 <= weightTaxRate) {
                    return (
                      <li className="CarsComparison__car-comparison__navigation__tax-item">
                        <span>
                          {'重量税 '}
                          <br/>
                          {'減税'}
                        </span>
                      </li>
                    )
                  } else {
                    return null;
                  }
                } else {
                  return null;
                }
              };
              return (
                <div>
                  <ul className="CarsComparison__car-comparison__navigation__tax">
                    {renderKankyowari()}
                    {renderSubsidy()}
                    {renderTax()}
                  </ul>
                </div>
              )
            } else {
              return (
                <div className="CarsComparison__car-comparison__navigation__blank"><span>-</span></div>
              )
            }
          } else {
            return (
              <div className="CarsComparison__car-comparison__navigation__blank"><span>-</span></div>
            );
          }
        };
        return (
          <dl className="CarsComparison__car-comparison__navigation__list-dl tax-info">
            <dt>エコカー</dt>
            {/*<dd className={(this.state.isLoading === true) ? 'loading' : ''}>*/}
            <dd>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderTaxInfoItem(this.state.selectedCarId, this.state.selectedCarTypeCode, this.bodyTypeInfo, this.state.selectedGradeId, this.state.selectedVariantId)}
              </div>
            </dd>
            {/*<dd className={(this.state.isLoading2 === true) ? 'loading' : ''}>*/}
            <dd>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderTaxInfoItem(this.state.selectedCarId2, this.state.selectedCarTypeCode2, this.bodyTypeInfo2, this.state.selectedGradeId2, this.state.selectedVariantId2)}
              </div>
            </dd>
            {/*<dd className={(this.state.isLoading3 === true) ? 'loading' : ''}>*/}
            <dd>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderTaxInfoItem(this.state.selectedCarId3, this.state.selectedCarTypeCode3, this.bodyTypeInfo3, this.state.selectedGradeId3, this.state.selectedVariantId3)}
              </div>
            </dd>
          </dl>
        )
      };

      // 見積もりシミュレーション
      const renderCta = () => {
        const renderCtaItem = (carId, carTypeCode, bodyTypeInfo, gradeId, variantId) => {
          if (bodyTypeInfo) {
            const generationInfo = this.getGenerationInfo(carId, carTypeCode);
            if (generationInfo.endOfSale === false) {
              //const gradeInfo = this.getGradeInfo(bodyTypeInfo, gradeId);
              const variantInfo = this.getVariantInfo(bodyTypeInfo, gradeId, variantId);
              if(carId === "mazda-spirit-racing-roadster"){
                return (
                  <div className="CarsComparison__car-comparison__navigation__blank"><span>-</span></div>
                );
              }
              return (
                <div>
                  <EstimateLink {...{
                    label: '見積りシミュレーション',
                    targetBlank: false,
                    color: 'Dark',
                    buttonStyle: 'Action',
                    linkType: 'Button',
                    carId: carId,
                    carTypeCode: carTypeCode,
                    //gradeCode: gradeInfo.gradeCode,
                    gradeCode: variantInfo.gradeCode,
                    drive: variantInfo.drive,
                    mission: variantInfo.transmission,
                    engine: variantInfo.engine,
                    ecode: null,
                    soptions: null,
                    direct: 'Result',
                  }}/>
                </div>
              )
            } else {
              return (
                <div className="CarsComparison__car-comparison__navigation__blank"><span>-</span></div>
              )
            }
          } else {
            return (
              <div className="CarsComparison__car-comparison__navigation__blank"><span>-</span></div>
            );
          }
        };
        return (
          <dl className="CarsComparison__car-comparison__navigation__list-dl last cta">
            <dt><span style={{visibility: 'hidden'}}>見積りシミュレーション</span></dt>
            {/*<dd className={(this.state.isLoading === true) ? 'loading' : ''}  style={(this.state.openLeftCondition === true) ? {backgroundColor: '#ffffff'} : null}>*/}
            <dd style={(this.state.openLeftCondition === true) ? {backgroundColor: '#ffffff'}: null}>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderCtaItem(this.state.selectedCarId, this.state.selectedCarTypeCode, this.bodyTypeInfo, this.state.selectedGradeId, this.state.selectedVariantId)}
              </div>
            </dd>
            {/*<dd className={(this.state.isLoading2 === true) ? 'loading' : ''}  style={(this.state.openCenterCondition === true) ? {backgroundColor: '#ffffff'} : null}>*/}
            <dd style={(this.state.openCenterCondition === true) ? {backgroundColor: '#ffffff'}: null}>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderCtaItem(this.state.selectedCarId2, this.state.selectedCarTypeCode2, this.bodyTypeInfo2, this.state.selectedGradeId2, this.state.selectedVariantId2)}
              </div>
            </dd>
            {/*<dd className={(this.state.isLoading3 === true) ? 'loading' : ''}  style={(this.state.openRightCondition === true) ? {backgroundColor: '#ffffff'} : null}>*/}
            <dd style={(this.state.openRightCondition === true) ? {backgroundColor: '#ffffff'}: null}>
              <div className="CarsComparison__car-comparison__navigation__box">
                {renderCtaItem(this.state.selectedCarId3, this.state.selectedCarTypeCode3, this.bodyTypeInfo3, this.state.selectedGradeId3, this.state.selectedVariantId3)}
              </div>
            </dd>
          </dl>
        )
      };

      // 条件を変更ボタン（SP）
      const renderCondition = () => {
        return (
          <dl className="CarsComparison__car-comparison__navigation__list-dl condition">
            <dt></dt>
            <dd style={(this.state.openLeftCondition === true) ? {backgroundColor: '#ffffff'}: null}>
              <div className="CarsComparison__car-comparison__navigation__box">
                <a
                  className={'CarsComparison__car-comparison__navigation__link-condition' + ((this.state.openLeftCondition === true) ? ' open': '')}
                  href="javascript:void(0);" onClick={(e) => {
                  e.preventDefault();
                  //
                  this.setState({
                    openLeftCondition: !this.state.openLeftCondition,
                    openCenterCondition: false,
                    openRightCondition: false,
                  })
                }}>条件を変更</a>
              </div>
            </dd>
            <dd style={(this.state.openCenterCondition === true) ? {backgroundColor: '#ffffff'}: null}>
              <div className="CarsComparison__car-comparison__navigation__box">
                <a
                  className={'CarsComparison__car-comparison__navigation__link-condition' + ((this.state.openCenterCondition === true) ? ' open': '')}
                  href="javascript:void(0);" onClick={(e) => {
                  e.preventDefault();
                  //
                  this.setState({
                    openLeftCondition: false,
                    openCenterCondition: !this.state.openCenterCondition,
                    openRightCondition: false,
                  })
                }}>条件を変更</a>
              </div>
            </dd>
            <dd style={(this.state.openRightCondition === true) ? {backgroundColor: '#ffffff'}: null}>
              <div className="CarsComparison__car-comparison__navigation__box">
                <a
                  className={'CarsComparison__car-comparison__navigation__link-condition' + ((this.state.openRightCondition === true) ? ' open': '')}
                  href="javascript:void(0);" onClick={(e) => {
                  e.preventDefault();
                  //
                  this.setState({
                    openLeftCondition: false,
                    openCenterCondition: false,
                    openRightCondition: !this.state.openRightCondition,
                  })
                }}>条件を変更</a>
              </div>
            </dd>
          </dl>
        )
      };

      let cls = '';
      if (this.state.openLeftCondition === true) cls = ' open-left';
      if (this.state.openCenterCondition === true) cls = ' open-center';
      if (this.state.openRightCondition === true) cls = ' open-right';

      return (
        <div className="CarsComparison__car-comparison__navigation">
          <div
            className={'CarsComparison__car-comparison__navigation__container' + ((this.state.isLoading === true || this.state.isLoading2 === true || this.state.isLoading3 === true) ? ' loading': '')}>
            {renderImage()}
            {renderGrade2()}
            {renderPrice2()}
            <div className="CarsComparison__car-comparison__navigation__container2">
              {renderCondition()}
              <div className={'CarsComparison__car-comparison__navigation__container3' + cls}
                   style={{width: this.state.windowWidth}}>
                {renderBodyType()}
                {renderReleaseDate()}
                {renderGrade()}
                {renderVariant()}
                {renderPrice()}
                {renderTaxInfo()}
                <a className="CarsComparison__car-comparison__navigation__link-close" href="javascript:void(0);"
                   onClick={(e) => {
                     e.preventDefault();
                     //
                     this.setState({
                       openLeftCondition: false,
                       openCenterCondition: false,
                       openRightCondition: false,
                     })
                   }}>閉じる</a>
              </div>
            </div>
            {renderCta()}
          </div>
        </div>
      )
    };

    // 詳細
    const renderSpecDescription = () => {
      const getDescription = () => {
        if (this.props.specDescription && this.props.specDescription !== '') {
          return this.props.specDescription;
        } else {
          return '';
        }
      };
      const getMbDescription = () => {
        if (this.props.mbSpecDescription && this.props.mbSpecDescription !== '') {
          return this.props.mbSpecDescription;
        } else {
          return getDescription();
        }
      };
      const description = getDescription();
      const mbDescription = getMbDescription();
      if (description && description !== "") {
        return (
          <div className="CarsComparison__car-comparison__spec-description">
            <p className="CarsComparison__car-comparison__spec-description__paragraph Wysiwyg">
              <span className="CarsComparison__car-comparison__spec-description__paragraph-pc"
                    dangerouslySetInnerHTML={{__html: description}}/>
              <span className="CarsComparison__car-comparison__spec-description__paragraph-mb"
                    dangerouslySetInnerHTML={{__html: mbDescription}}/>
            </p>
          </div>
        )
      } else {
        return null;
      }
    };

    // 固定ナビゲーション
    const renderFixedNavigation = () => {

      const renderImage = (carId) => {
        if (carId) {
          const modelInfo = this.getModelInfo(carId);
          return (
            <img className="CarsComparison__car-comparison__fixed-navigation__car-image" src={modelInfo.src}/>
          )
        } else {
          return (
            <img className="CarsComparison__car-comparison__fixed-navigation__car-image" src={CarSelector.imageCar}
                 alt=""/>
          );
        }
      };

      const renderBodyType = (carId, carTypeCode, bodyTypeInfo, gradeId) => {

        // 100th Anniversary Special Edition > 100周年特別記念車
        const convert100th = (text) => {
          if (text && text !== '') {
            text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '100周年特別記念車 2020 WCDOTY受賞記念モデル');
            text = text.replace('100th Anniversary Special Edition', '100周年特別記念車');
            text = text.replace('100th Anniv Special Edition 2020 WCOTY TOP3 Model', '100周年特別記念車 2020 WCOTY TOP3選出記念モデル');
            text = text.replace('RF 35th SV', '35周年記念車');
            text = text.replace('35th SV', '35周年記念車');
            text = text.replace('XD BD Black', 'XD BD インパネ：グロスブラック');
            text = text.replace('XD BD Light Blue', 'XD BD インパネ：グロスライトブルー');
            text = text.replace('XD BD White', 'XD BD インパネ：ピュアホワイト');
            text = text.replace('15 BD i Selection Black', '15 BD i Selection インパネ：グロスブラック');
            text = text.replace('15 BD i Selection Light Blue', '15 BD i Selection インパネ：グロスライトブルー');
            text = text.replace('15 BD i Selection White', '15 BD i Selection インパネ：ピュアホワイト');
            text = text.replace('15S Leather Touring Selection Black', '15S Leather Touring Selection（ブラックレザーパッケージ）');
            text = text.replace('15S Leather Touring Selection Burgundy', '15S Leather Touring Selection（バーガンディレザーパッケージ）');
            text = text.replace('X Touring Black', 'X Touring(ブラックレザーパッケージ)');
            text = text.replace('X Touring Burgundy', 'X Touring(バーガンディレザーパッケージ)');
            text = text.replace('15 SPORT Plus', '15 SPORT＋');
            text = text.replace('XD SPORT Plus', 'XD SPORT＋');
            return text;
          } else {
            return text;
          }
        };

        if (carId) {
          const modelInfo = this.getModelInfo(carId);
          if (bodyTypeInfo && gradeId) {
            const gradeInfo = this.getGradeInfo(bodyTypeInfo, gradeId);
            let label = gradeInfo.gradeName;
            if (gradeInfo.specialCar === 'true' || gradeInfo.specialCar === true) {
              label = gradeInfo.gradeId;
            } else {
              if (!label || label === '') {
                label = gradeInfo.gradeId;
              }
            }
            label = label.replace(/[|]/g, ' ');
            return (
              <p className="CarsComparison__car-comparison__fixed-navigation__body-type">
                {convert100th(modelInfo.bodyTypeModel)}
                <br />
                {convert100th(label)}
                {/*{modelInfo.bodyTypeModel + ' ' + gradeInfo.gradeId}*/}
              </p>
            )
          } else {
            return (
              <p className="CarsComparison__car-comparison__fixed-navigation__body-type">
                {convert100th(modelInfo.bodyTypeModel)}
              </p>
            )
          }
        } else {
          return (
            <div className="CarsComparison__car-comparison__fixed-navigation__blank"><span>-</span></div>
          );
        }
      };

      const renderPrice = (carId, carTypeCode, bodyTypeInfo, gradeId, variantId) => {
        if (bodyTypeInfo) {
          const generationInfo = this.getGenerationInfo(carId, carTypeCode);
          if (generationInfo.endOfSale === false) {
            const variantInfo = this.getVariantInfo(bodyTypeInfo, gradeId, variantId);
            return (
              <p className="CarsComparison__car-comparison__fixed-navigation__price">
                {this.formatPrice(variantInfo.price)}
                <span>〜<br/>（消費税込）</span>
              </p>
            )
          } else {
            return (
              <div className="CarsComparison__car-comparison__fixed-navigation__end-of-sale">生産終了</div>
            )
          }
        } else {
          return (
            <div className="CarsComparison__car-comparison__fixed-navigation__blank"><span>-</span></div>
          );
        }
      };

      return (
        <div
          className={'CarsComparison__car-comparison__fixed-navigation' + ((this.state.fixedNavigationOpened === true) ? ' open': '')}
          style={{'top': this.state.subNavigationHeight}}>
          <div className="CarsComparison__car-comparison__fixed-navigation__container" ref="navigation">
            <div className="CarsComparison__car-comparison__fixed-navigation__container2">
              <div className="CarsComparison__car-comparison__fixed-navigation__container3">
                <a className="CarsComparison__car-comparison__fixed-navigation__link2" href="javascript:void(0);"
                   onClick={(e) => {
                     e.preventDefault();
                     //
                     BodyControl.scrollToNode(this.refs.condition);
                   }}
                ><span>比較条件を変更する</span></a>
                <ul className="CarsComparison__car-comparison__fixed-navigation__list">
                  <li>
                    <a className="CarsComparison__car-comparison__fixed-navigation__link" href="javascript:void(0);"
                       onClick={(e) => {
                         e.preventDefault();
                         //
                         BodyControl.scrollToNode(this.refs.condition);
                       }}>比較条件を変更する</a>
                  </li>
                  <li>
                    {renderImage(this.state.selectedCarId)}
                    <div style={{height: this.state.fixedNavigationBodyTypeHeight}}>
                      <div ref='fixedNavigationBodyType'>
                        {renderBodyType(this.state.selectedCarId, this.state.selectedCarTypeCode, this.bodyTypeInfo, this.state.selectedGradeId)}
                      </div>
                    </div>
                    {renderPrice(this.state.selectedCarId, this.state.selectedCarTypeCode, this.bodyTypeInfo, this.state.selectedGradeId, this.state.selectedVariantId)}
                  </li>
                  <li>
                    {renderImage(this.state.selectedCarId2)}
                    <div style={{height: this.state.fixedNavigationBodyTypeHeight}}>
                      <div ref='fixedNavigationBodyType2'>
                        {renderBodyType(this.state.selectedCarId2, this.state.selectedCarTypeCode2, this.bodyTypeInfo2, this.state.selectedGradeId2)}
                      </div>
                    </div>
                    {renderPrice(this.state.selectedCarId2, this.state.selectedCarTypeCode2, this.bodyTypeInfo2, this.state.selectedGradeId2, this.state.selectedVariantId2)}
                  </li>
                  <li>
                    {renderImage(this.state.selectedCarId3)}
                    <div style={{height: this.state.fixedNavigationBodyTypeHeight}}>
                      <div ref='fixedNavigationBodyType3'>
                        {renderBodyType(this.state.selectedCarId3, this.state.selectedCarTypeCode3, this.bodyTypeInfo3, this.state.selectedGradeId3)}
                      </div>
                    </div>
                    {renderPrice(this.state.selectedCarId3, this.state.selectedCarTypeCode3, this.bodyTypeInfo3, this.state.selectedGradeId3, this.state.selectedVariantId3)}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )
    };

    return (
      <div className="CarsComparison__car-comparison">
        <div className="CarsComparison__car-comparison__container">
          {renderDescription()}
        </div>
        <div className="CarsComparison__car-comparison__container2" ref="condition">
          {renderNavigation()}
        </div>
        <div className="CarsComparison__car-comparison__container" ref="spec">
          <CarComparisonDetail {...this.getSpecComparisonProps()} ref="carComparisonDetail"/>
          {renderSpecDescription()}
        </div>
        {(this.props.freeArea && 1 <= this.props.freeArea.length) ? getComponents(this.props.freeArea): null}
        <div>
          {renderFixedNavigation()}
        </div>
      </div>
    );
  }

  //
  handleResize = () => {
    const windowTop = window.pageYOffset;
    this.navigationTop = this.refs.navigation.getBoundingClientRect().top + windowTop;
    this.navigationHeight = this.refs.navigation.getBoundingClientRect().height;
    this.specTop = this.refs.spec.getBoundingClientRect().top + windowTop;
    this.specHeight = this.refs.spec.getBoundingClientRect().height;
    this.subNavigationHeight = BodyControl.getSubNavigationHeight();

    //
    let maxHeight = this.refs.fixedNavigationBodyType.getBoundingClientRect().height;
    let h = this.refs.fixedNavigationBodyType2.getBoundingClientRect().height;
    if (0 < h && maxHeight < h) maxHeight = h;
    h = this.refs.fixedNavigationBodyType3.getBoundingClientRect().height;
    if (0 < h && maxHeight < h) maxHeight = h;
    maxHeight = (0 < maxHeight) ? maxHeight + 5 : 'auto';

    //
    this.setState({
      subNavigationHeight: this.subNavigationHeight,
      windowWidth: window.innerWidth,
      fixedNavigationBodyTypeHeight: maxHeight,
    })
  };

  //
  handleScroll = () => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (this.specTop - this.subNavigationHeight <= scrollTop) {
      if (scrollTop + (this.navigationHeight + this.subNavigationHeight) <= this.specTop + this.specHeight) {
        if (this.state.fixedNavigationOpened === false) {
          this.setState({
            fixedNavigationOpened: true,
          });
        }
      } else {
        if (this.state.fixedNavigationOpened === true) {
          this.setState({
            fixedNavigationOpened: false,
          });
        }
      }
    } else {
      if (this.state.fixedNavigationOpened === true) {
        this.setState({
          fixedNavigationOpened: false,
        });
      }
    }
  };

  // APIアクセス
  accessApi = (data) => {

    //console.log('APIアクセス');
    //console.log(data);

    // ローディング表現
    const setLoading = () => {
      if (data[0] && data[0].carId) data[0].carId = data[0].carId.toLowerCase();
      if (data[1] && data[1].carId) data[1].carId = data[1].carId.toLowerCase();
      if (data[2] && data[2].carId) data[2].carId = data[2].carId.toLowerCase();
      let isLoading = false;
      if (data[0] && data[0].carId && data[0].carTypeCode) {
        isLoading = true;
      }
      let isLoading2 = false;
      if (data[1] && data[1].carId && data[1].carTypeCode) {
        isLoading2 = true;
      }
      let isLoading3 = false;
      if (data[2] && data[2].carId && data[2].carTypeCode) {
        isLoading3 = true;
      }
      this.setState({
        isLoading: isLoading,
        isLoading2: isLoading2,
        isLoading3: isLoading3,
      });
    };

    // 静的JSONファイルを取得
    const accessApiStatic = () => {
      //console.log('静的JSONファイルを取得');
      setTimeout(() => {
        //console.log('APIレスポンス');
        let bodyTypes = null;
        if (data[0] && data[0].carId === 'demio' && data[0].carTypeCode === 'DE8' && data[1] && data[1].carId === 'axela-sport' && data[1].carTypeCode === 'BM5') {
          bodyTypes = demioDE8_axelasportBM5.bodyTypes;
        } else if (data[1] && data[1].carId === 'axela-sedan' && data[1].carTypeCode === 'BM6') {
          bodyTypes = axelasedanBM6.bodyTypes;
        } else if (data[0] && data[0].carId === 'demio' && data[0].carTypeCode === 'DE7') {
          bodyTypes = demioDE7.bodyTypes;
        } else if (data[0] && data[0].carId === 'atenze-sadan' && data[0].carTypeCode === 'GJ7') {
          bodyTypes = atenzasedanGJ7.bodyTypes;
        }
        //
        if (bodyTypes) {
          // 1つ目変更
          if (data[0] && data[0].carId && data[0].carTypeCode) {
            let i, max;
            for (i = 0, max = bodyTypes.length; i < max; i = i + 1) {
              const bodyType = bodyTypes[i];
              if (data[0].carId === bodyType.carId && data[0].carTypeCode === bodyType.generation.carTypeCode) {
                this.bodyTypeInfo = bodyType;
                const defaultGradeId = this.getDefaultGradeId(bodyType);
                const defaultVariantId = this.getDefaultVariantId(bodyType, defaultGradeId);
                this.setState({
                  selectedCarId: data[0].carId,
                  selectedCarTypeCode: data[0].carTypeCode,
                  selectedGradeId: defaultGradeId,
                  selectedVariantId: defaultVariantId,
                  isLoading: false,
                });
              }
            }
          }
          // 2つ目変更
          if (data[1] && data[1].carId && data[1].carTypeCode) {
            let i, max;
            for (i = 0, max = bodyTypes.length; i < max; i = i + 1) {
              const bodyType = bodyTypes[i];
              if (data[1].carId === bodyType.carId && data[1].carTypeCode === bodyType.generation.carTypeCode) {
                this.bodyTypeInfo2 = bodyType;
                const defaultGradeId = this.getDefaultGradeId(bodyType);
                const defaultVariantId = this.getDefaultVariantId(bodyType, defaultGradeId);
                this.setState({
                  selectedCarId2: data[1].carId,
                  selectedCarTypeCode2: data[1].carTypeCode,
                  selectedGradeId2: defaultGradeId,
                  selectedVariantId2: defaultVariantId,
                  isLoading2: false,
                });
              }
            }
          }
          // 3つ目変更
          if (data[2] && data[2].carId && data[2].carTypeCode) {
            let i, max;
            for (i = 0, max = bodyTypes.length; i < max; i = i + 1) {
              const bodyType = bodyTypes[i];
              if (data[2].carId === bodyType.carId && data[2].carTypeCode === bodyType.generation.carTypeCode) {
                this.bodyTypeInfo3 = bodyType;
                const defaultGradeId = this.getDefaultGradeId(bodyType);
                const defaultVariantId = this.getDefaultVariantId(bodyType, defaultGradeId);
                this.setState({
                  selectedCarId3: data[2].carId,
                  selectedCarTypeCode3: data[2].carTypeCode,
                  selectedGradeId3: defaultGradeId,
                  selectedVariantId3: defaultVariantId,
                  isLoading3: false,
                });
              }
            }
          }
        }
        // スペック変更
        this.refs.carComparisonDetail.changeSpecs();
      }, 3000)
    };

    // 動的JSONファイルを取得
    const accessApiDynamic = () => {
      //console.log('動的JSONファイルを取得');
      const params = new URLSearchParams();
      if (data[0] && data[0].carId && data[0].carTypeCode) {
        params.set('carId', data[0].carId);
        params.set('carTypeCode', data[0].carTypeCode);
      }
      if (data[1] && data[1].carId && data[1].carTypeCode) {
        params.set('carId2', data[1].carId);
        params.set('carTypeCode2', data[1].carTypeCode);
      }
      if (data[2] && data[2].carId && data[2].carTypeCode) {
        params.set('carId3', data[2].carId);
        params.set('carTypeCode3', data[2].carTypeCode);
      }
      //params.set('carId', 'atenza-sedan');
      //params.set('carTypeCode', 'GJ7');

      //let apiUrl = '/api/mjo/automotive/cars-comparison?';
      let apiUrl = null;
      if (0 <= String(location.hostname).indexOf('localhost')) {
        // apiUrl = 'http://uat.mazda.co.jp/api/mjo/automotive/cars-comparison?';
        apiUrl = 'http://dev.mazda.co.jp/api/mjo/automotive/cars-comparison?';
      } else {
        apiUrl = '/api/mjo/automotive/cars-comparison?';
      }

      /*
      // let xhr = new XMLHttpRequest();
      this.xhr.onreadystatechange = (e, e2) => {
        if (this.xhr.readyState === 4 && this.xhr.status === 200) {
          // 本番
          console.log('本番');
          console.log(this.xhr.responseText);
        } else if (this.xhr.readyState === 4 && this.xhr.status === 0) {
          // ローカル
          console.log('ローカル');
          console.log(this.xhr.responseText);
        } else {
        }
      };
      this.xhr.open('GET', apiUrl + params.toString(), true);
      this.xhr.setRequestHeader('Accept', 'application/json');
      this.xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      // this.xhr.setRequestHeader('Content-Type', 'application/json');
      this.xhr.send();
      this.xhr.abort();
      return;
      */

      //fetch('/api/mjo/automotive/cars-comparison?' + params.toString(), {
      fetch(apiUrl + params.toString(), {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
          // 'Content-Type': 'application/json',
        },
        method: 'GET',
        mode: 'cors',
        // mode: 'same-origin',
      }).then((response) => {
        return response.json();
      }).then((json) => {
        // console.log('APIレスポンス');
        // console.log(json);
        //
        let bodyTypes = json.bodyTypes || null;
        if (bodyTypes) {
          // 1つ目変更
          if (data[0] && data[0].carId && data[0].carTypeCode) {
            let i, max;
            for (i = 0, max = bodyTypes.length; i < max; i = i + 1) {
              const bodyType = bodyTypes[i];
              if (isEqualId(data[0].carId, bodyType.carId) && isEqualId(data[0].carTypeCode, bodyType.generation.carTypeCode)) {
                this.bodyTypeInfo = bodyType;
                //const defaultGradeId = this.getDefaultGradeId(bodyType);

                // 初期パラメータによってデフォルトグレードを変更
                let defaultGradeId = null;
                if (this.selectedGradeId) {
                  defaultGradeId = this.selectedGradeId;
                  this.selectedGradeId = null;
                } else {
                  defaultGradeId = this.getDefaultGradeId(bodyType);
                }

                const defaultVariantId = this.getDefaultVariantId(bodyType, defaultGradeId);
                this.setState({
                  selectedCarId: data[0].carId,
                  selectedCarTypeCode: data[0].carTypeCode,
                  selectedGradeId: defaultGradeId,
                  selectedVariantId: defaultVariantId,
                  isLoading: false,
                });

                break;

              }
            }
          }
          // 2つ目変更
          if (data[1] && data[1].carId && data[1].carTypeCode) {
            let i, max;
            for (i = 0, max = bodyTypes.length; i < max; i = i + 1) {
              const bodyType = bodyTypes[i];
              if (isEqualId(data[1].carId, bodyType.carId) && isEqualId(data[1].carTypeCode, bodyType.generation.carTypeCode)) {
                this.bodyTypeInfo2 = bodyType;
                //const defaultGradeId = this.getDefaultGradeId(bodyType);

                // 初期パラメータによってデフォルトグレードを変更
                let defaultGradeId = null;
                if (this.selectedGradeId2) {
                  defaultGradeId = this.selectedGradeId2;
                  this.selectedGradeId2 = null;
                } else {
                  defaultGradeId = this.getDefaultGradeId(bodyType);
                }

                const defaultVariantId = this.getDefaultVariantId(bodyType, defaultGradeId);
                this.setState({
                  selectedCarId2: data[1].carId,
                  selectedCarTypeCode2: data[1].carTypeCode,
                  selectedGradeId2: defaultGradeId,
                  selectedVariantId2: defaultVariantId,
                  isLoading2: false,
                });

                break;

              }
            }
          }
          // 3つ目変更
          if (data[2] && data[2].carId && data[2].carTypeCode) {
            let i, max;
            for (i = 0, max = bodyTypes.length; i < max; i = i + 1) {
              const bodyType = bodyTypes[i];
              if (isEqualId(data[2].carId, bodyType.carId) && isEqualId(data[2].carTypeCode, bodyType.generation.carTypeCode)) {
                this.bodyTypeInfo3 = bodyType;
                //const defaultGradeId = this.getDefaultGradeId(bodyType);

                // 初期パラメータによってデフォルトグレードを変更
                let defaultGradeId = null;
                if (this.selectedGradeId3) {
                  defaultGradeId = this.selectedGradeId3;
                  this.selectedGradeId3 = null;
                } else {
                  defaultGradeId = this.getDefaultGradeId(bodyType);
                }

                const defaultVariantId = this.getDefaultVariantId(bodyType, defaultGradeId);
                this.setState({
                  selectedCarId3: data[2].carId,
                  selectedCarTypeCode3: data[2].carTypeCode,
                  selectedGradeId3: defaultGradeId,
                  selectedVariantId3: defaultVariantId,
                  isLoading3: false,
                });

                break;

              }
            }
          }
        }
        // スペック変更
        this.refs.carComparisonDetail.changeSpecs();
      });
    };

    // ローディング表現
    setLoading();

    // 静的JSONファイルを取得
    // accessApiStatic();

    // 動的JSONファイルを取得
    // accessApiDynamic();

    if (0 <= String(location.hostname).indexOf('localhost')) {
      // 静的JSONファイルを取得
      accessApiStatic();
    } else {
      // 動的JSONファイルを取得
      accessApiDynamic();
    }

  };

  // グレード変更
  changeGrade = (gradeId, index) => {
    if (index === 0) {
      this.setState({
        selectedGradeId: gradeId,
        selectedVariantId: this.getDefaultVariantId(this.bodyTypeInfo, gradeId),
      })
    } else if (index === 1) {
      this.setState({
        selectedGradeId2: gradeId,
        selectedVariantId2: this.getDefaultVariantId(this.bodyTypeInfo2, gradeId),
      })
    } else if (index === 2) {
      this.setState({
        selectedGradeId3: gradeId,
        selectedVariantId3: this.getDefaultVariantId(this.bodyTypeInfo3, gradeId),
      })
    }
    // スペック変更
    this.refs.carComparisonDetail.changeSpecs();
  };

  // 機種変更
  changeVariant = (variantId, index) => {
    if (index === 0) {
      this.setState({
        selectedVariantId: variantId,
      })
    } else if (index === 1) {
      this.setState({
        selectedVariantId2: variantId,
      })
    } else if (index === 2) {
      this.setState({
        selectedVariantId3: variantId,
      })
    }
    // スペック変更
    this.refs.carComparisonDetail.changeSpecs();
  };

  // CarIdを元にModel情報を取得
  getModelInfo = (carId) => {
    let i, max;
    for (i = 0, max = this.props.models.length; i < max; i = i + 1) {
      const model = this.props.models[i];
      if (isEqualId(model.carId, carId)) {
        return model;
      }
    }
    return null;
  };

  // CarIdとCarTypeCodeを元にGeneration情報を取得
  getGenerationInfo = (carId, carTypeCode) => {
    const model = this.getModelInfo(carId);
    let i, max;
    for (i = 0, max = model.generations.length; i < max; i = i + 1) {
      const generation = model.generations[i];
      if (isEqualId(generation.carTypeCode, carTypeCode)) {
        return generation;
      }
    }
    return null;
  };

  // グレード情報
  getGradesInfo = (bodyTypeInfo) => {
    return bodyTypeInfo.generation.grades;
  };

  // グレード情報
  getGradeInfo = (bodyTypeInfo, gradeId) => {
    const gradesInfo = this.getGradesInfo(bodyTypeInfo);
    let i, max;
    for (i = 0, max = gradesInfo.length; i < max; i = i + 1) {
      const gradeInfo = gradesInfo[i];
      if (gradeInfo.gradeId === gradeId) {
        return gradeInfo;
      }
    }
    return null;
  };

  // デフォルトグレードID
  getDefaultGradeId = (bodyTypeInfo) => {
    const gradeId = bodyTypeInfo.generation.defaultGradeId;
    if (gradeId) {
      return gradeId;
    } else {
      return bodyTypeInfo.generation.grades[0].gradeId;
    }
  };

  // 機種情報
  getVariantsInfo = (bodyTypeInfo, gradeId) => {
    const gradeInfo = this.getGradeInfo(bodyTypeInfo, gradeId);
    return gradeInfo.variants;
  };

  // 機種情報
  getVariantInfo = (bodyTypeInfo, gradeId, variantId) => {
    const variantsInfo = this.getVariantsInfo(bodyTypeInfo, gradeId);
    let i, max;
    for (i = 0, max = variantsInfo.length; i < max; i = i + 1) {
      const variantInfo = variantsInfo[i];
      if (variantInfo.variantId === variantId) {
        return variantInfo;
      }
    }
    return null;
  };

  // デフォルト機種ID
  getDefaultVariantId = (bodyTypeInfo, gradeId) => {
    const gradeInfo = this.getGradeInfo(bodyTypeInfo, gradeId);
    const variantsInfo = this.getVariantsInfo(bodyTypeInfo, gradeId);
    let i, max;
    for (i = 0, max = variantsInfo.length; i < max; i = i + 1) {
      const variantInfo = variantsInfo[i];
      if (variantInfo.drive === gradeInfo.defaultDrive && variantInfo.transmission === gradeInfo.defaultMission) {
        return variantInfo.variantId;
      }
    }
    return variantsInfo[0].variantId;
  };

  // スペック比較情報取得
  getSpecComparisonProps = () => {

    const getModelNameByCarId = (carId)=> {
      let i, max;
      for (i = 0, max = this.props.models.length; i < max; i = i + 1) {
        const model = this.props.models[i];
        if (isEqualId(model.carId, carId)) {
          return model.modelName;
        }
      }
      return null;
    };

    let gradeInfo = null;
    let gradeInfo2 = null;
    let gradeInfo3 = null;
    if (this.bodyTypeInfo) {
      const variantInfo = this.getVariantInfo(this.bodyTypeInfo, this.state.selectedGradeId, this.state.selectedVariantId);
      gradeInfo = {
        modelName: getModelNameByCarId(this.state.selectedCarId),
        carId: this.state.selectedCarId,
        carTypeCode: this.state.selectedCarTypeCode,
        gradeId: this.state.selectedGradeId,
        specs: variantInfo.specs,
      }
    }
    if (this.bodyTypeInfo2) {
      const variantInfo = this.getVariantInfo(this.bodyTypeInfo2, this.state.selectedGradeId2, this.state.selectedVariantId2);
      gradeInfo2 = {
        modelName: getModelNameByCarId(this.state.selectedCarId2),
        carId: this.state.selectedCarId2,
        carTypeCode: this.state.selectedCarTypeCode2,
        gradeId: this.state.selectedGradeId2,
        specs: variantInfo.specs,
      }
    }
    if (this.bodyTypeInfo3) {
      const variantInfo = this.getVariantInfo(this.bodyTypeInfo3, this.state.selectedGradeId3, this.state.selectedVariantId3);
      gradeInfo3 = {
        modelName: getModelNameByCarId(this.state.selectedCarId3),
        carId: this.state.selectedCarId3,
        carTypeCode: this.state.selectedCarTypeCode3,
        gradeId: this.state.selectedGradeId3,
        specs: variantInfo.specs,
      }
    }
    return {compareGrades: [gradeInfo, gradeInfo2, gradeInfo3]};
  };

  // YYYYMMをYYYY年M月D日にフォーマト
  formatReleaseDate = (YYYYMMDD = null) => {
    if (!YYYYMMDD || YYYYMMDD === '') return '';
    let str = String(YYYYMMDD).substr(0, 4) + '年';
    str = str + Number(String(YYYYMMDD).substr(4, 2)) + '月';
    return str;
  };

  // 金額フォーマット
  formatPrice = (num) => {
    return '¥' + String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  };

}

/**
 *  CarComparisonDetail
 */
class CarComparisonDetail extends Component {
  static propTypes = {
    compareGrades: PropTypes.arrayOf(PropTypes.shape(
      {
        modelName: PropTypes.string,
        carId: PropTypes.string,
        carTypeCode: PropTypes.string,
        gradeId: PropTypes.string,
        specs: PropTypes.arrayOf(PropTypes.shape(
          {
            category: PropTypes.string,
            name: PropTypes.string,
            value: PropTypes.arrayOf(PropTypes.string),
            unit: PropTypes.string,
            description: PropTypes.string,
            seatImageSrc: PropTypes.string,
          },
        )),
      },
    )),
  };
  static defaultProps = {
    compareGrades: [],
  };

  constructor(props) {
    super();
    this.props = props;
    //
    this.state = {
      openAccordion: false,
      isMounted: false,
    };
    this.accordionRefs = [];
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }

  componentWillUpdate(nextProps) {
    //console.log(nextProps);
  }

  componentDidMount() {
    this.setState({
      isMounted: true,
    });
  };

  componentWillUnmount() {
    this.setState({
      isMounted: false,
    });
  }

  render() {

    // マスタースペックカテゴリ取得
    const _getMasterSpecCategory = () => {

      const removeDuplicateValue = (arr) => {
        return arr.filter((val, i, self) => {
          return self.indexOf(val) === i;
        });
      };

      // カテゴリー一覧
      let categoryArr = [];
      this.props.compareGrades.map((compareGrade, index) => {
        if (compareGrade && compareGrade.specs && 1 <= compareGrade.specs.length) {
          let i, max;
          for (i = 0, max = compareGrade.specs.length; i < max; i = i + 1) {
            if (compareGrade.specs[i].unit && compareGrade.specs[i].unit !== '' && compareGrade.specs[i].unit !== 'blank') {
              categoryArr.push(compareGrade.specs[i].category);
            } else {
              if (compareGrade.specs[i].value && compareGrade.specs[i].value[0] && compareGrade.specs[i].value[0] !== '') {
                categoryArr.push(compareGrade.specs[i].category);
              }
            }
          }
        }
      });
      categoryArr = removeDuplicateValue(categoryArr);

      // カテゴリー一覧を元に全てのスペック情報を取得
      let masterSpecCategory = [];

      //
      let i, max;
      for (i = 0, max = categoryArr.length; i < max; i = i + 1) {
        let category = categoryArr[i];
        let arr = [];

        //
        this.props.compareGrades.map((compareGrade, index) => {
          if (compareGrade && compareGrade.specs && 1 <= compareGrade.specs.length) {

            //
            let i, max;
            for (i = 0, max = compareGrade.specs.length; i < max; i = i + 1) {
              let specs = compareGrade.specs[i];
              if (specs.category === category) {

                // 重複しているかチェック
                let flg = true;
                let j, max2;
                for (j = 0, max2 = arr.length; j < max2; j = j + 1) {
                  if ((arr[j].name || '') === (specs.name || '') && (arr[j].description || '') === (specs.description || '')) {
                    flg = false;
                    break;
                  }
                }

                // 重複していなければ追加
                if (flg === true) {
                  if (specs.unit && specs.unit !== '' && specs.unit !== 'blank') {
                    arr.push({
                      name: specs.name || null,
                      description: specs.description || null,
                    });
                  } else {
                    if (specs.value && specs.value[0] && specs.value[0] !== '') {
                      arr.push({
                        name: specs.name || null,
                        description: specs.description || null,
                      });
                    }
                  }
                }

              }
            }

          }
        });

        masterSpecCategory.push({
          category: categoryArr[i],
          specs: arr,
        });

      }

      //console.log(JSON.stringify(masterSpecCategory));

      return masterSpecCategory;
    };

    // マスタースペックカテゴリ取得
    const getMasterSpecCategory = ()=> {
      if (window.MZD_SPEC_DATA_CATEGORY_LIST) {
        return window.MZD_SPEC_DATA_CATEGORY_LIST;
      } else {
        return _getMasterSpecCategory();
      }
    };

    // スペック情報取得
    const getSpecsInfo = (index) => {

      const removeDuplicateValue = (arr) => {
        return arr.filter((val, i, self) => {
          return self.indexOf(val) === i;
        });
      };

      const compareGrade = this.props.compareGrades[index] || null;
      let specs = null;
      if (compareGrade) {
        specs = compareGrade.specs || null;
      }

      if (specs && 1 <= specs.length) {
        // フォーマット
        let categoryArr = [];
        let i, max;
        for (i = 0, max = specs.length; i < max; i = i + 1) {
          categoryArr.push(specs[i].category);
        }
        categoryArr = removeDuplicateValue(categoryArr);
        //
        let specs2 = [];
        for (i = 0, max = categoryArr.length; i < max; i = i + 1) {
          const category = categoryArr[i];
          let obj = {
            category: category,
            specs: [],
          };
          let j, max2;
          for (j = 0, max2 = specs.length; j < max2; j = j + 1) {
            const spec = specs[j];
            if (category === spec.category) {
              obj.specs.push({
                name: spec.name || null,
                value: spec.value || null,
                unit: spec.unit || null,
                description: spec.description || null,
                seatImageSrc: spec.seatImageSrc || null,
              })
            }
          }
          specs2.push(obj);
        }
        return specs2;
      } else {
        return null;
      }
    };

    // 機種スペックデータからnameが一致するデータを取得
    const getSpecInfo = (specsInfo, category, name, description) => {
      if (specsInfo && 1 <= specsInfo.length) {
        let i, max;
        for (i = 0, max = specsInfo.length; i < max; i = i + 1) {
          if (specsInfo[i].category === category) {
            let j, max2;
            for (j = 0, max2 = specsInfo[i].specs.length; j < max2; j = j + 1) {
              if (specsInfo[i].specs[j].name === name && (specsInfo[i].specs[j].description || '') === (description || '')) {
                return specsInfo[i].specs[j];
              }
            }
          }
        }
      } else {
        return null;
      }
    };

    // スペックが存在するか
    const getIsExistSpecValue = (category, name, description)=> {
      let i, max;
      for (i = 0, max = this.props.compareGrades.length; i < max; i = i + 1) {
        const compareGrade = this.props.compareGrades[i];
        if (compareGrade && compareGrade.specs && 1 <= compareGrade.specs.length) {
          let j, max2;
          for (j = 0, max2 = compareGrade.specs.length; j < max2; j = j + 1) {
            const spec = compareGrade.specs[j];
            if (category === spec.category && name === spec.name) {
              if (description) {
                if (description === spec.description) {
                  if (spec.unit && spec.unit !== '' && spec.unit !== 'blank') {
                    return true
                  } else {
                    if (spec.value && spec.value[0] && spec.value[0] !== '') {
                      return true
                    }
                  }
                }
              } else {
                if (spec.description === '') {
                  if (spec.unit && spec.unit !== '' && spec.unit !== 'blank') {
                    return true
                  } else {
                    if (spec.value && spec.value[0] && spec.value[0] !== '') {
                      return true
                    }
                  }
                }
              }
            }
            // if (category === spec.category && name === spec.name && description === spec.description) {
            //   if (spec.unit && spec.unit !== '' && spec.unit !== 'blank') {
            //     return true
            //   } else {
            //     if (spec.value && spec.value[0] && spec.value[0] !== '') {
            //       return true
            //     }
            //   }
            // }
          }
        }
      }
      return false;
    };

    // ------ Render ----- //

    // スペックカテゴリ表示
    const renderSpecCategory = () => {
      const masterSpecCategory = getMasterSpecCategory();
      this.accordionRefs = [];
      return (
        masterSpecCategory.map((info, index) => {


          // スペックデータが有るか無しか
          let flg = false;
          let i, max;
          for (i = 0, max = info.specs.length; i < max; i = i + 1) {
            const spec = info.specs[i];
            if (getIsExistSpecValue(info.category, spec.name, spec.description)) {
              flg = true;
            }
          }
          if (!flg) return null;


          this.accordionRefs.push('accordion' + index);
          const isOpen = (index <= 0) ? true: false;
          return (
            <Accordion
              ref={'accordion' + index}
              pageName={info.category}
              pcText={info.category}
              mbText={info.category}
              open={isOpen}
              enabled={true}
              key={index}
            >
              <ul className="CarsComparison__car-comparison-detail__table">
                {renderSpecName(info.category, info.specs)}
              </ul>
            </Accordion>
          )
        })
      )
    };

    // スペック名表示
    const renderSpecName = (category, masterSpecs) => {
      return (
        masterSpecs.map((masterSpec, index) => {


          // スペックデータが有るか無しか
          if (!getIsExistSpecValue(category, masterSpec.name, masterSpec.description)) return null;


          let count = 0;
          return (
            <li className="CarsComparison__car-comparison-detail__table-row" key={index}>
              <div className="CarsComparison__car-comparison-detail__table-cell">
                {masterSpec.name + ' ' + ((masterSpec.description) ? masterSpec.description: '')}
              </div>
              {this.props.compareGrades.map((compareGrade, index2) => {
                count = count + 1;
                const specsInfo = getSpecsInfo(index2);
                if (specsInfo && 1 <= specsInfo.length) {
                  const specInfo = getSpecInfo(specsInfo, category, masterSpec.name, masterSpec.description);
                  if (specInfo) {
                    return (
                      <div className="CarsComparison__car-comparison-detail__table-cell" key={index2}>
                        {renderSpecValue(category, specInfo, compareGrade)}
                      </div>
                    )
                  } else {
                    return (
                      <div className="CarsComparison__car-comparison-detail__table-cell" key={index2}><span className="CarsComparison__car-comparison-detail__blank">-</span></div>
                    )
                  }
                } else {
                  return (
                    <div className="CarsComparison__car-comparison-detail__table-cell" key={index2}><span className="CarsComparison__car-comparison-detail__blank">-</span></div>
                  )
                }
              })}
              {(() => {
                if (count <= 2) {
                  return (
                    <div className="CarsComparison__car-comparison-detail__table-cell"><span className="CarsComparison__car-comparison-detail__blank">-</span></div>
                  )
                }
              })()}
            </li>
          )
        })
      );
    };

    // 機種スペック値表示
    const renderSpecValue = (category, spec, compareGrade) => {

      // メディアディレクトリ取得
      const getMediaDirectory = () => {
        if (this.state.isMounted === false) return '/assets-dev/';
        if (0 <= String(location.hostname).indexOf('localhost')) {
          return '/assets-dev/';
        } else {
          return '/globalassets/';
        }
      };

      const formatSrc = (src) => {
        if (this.state.isMounted === false) return src;
        if (0 <= String(location.hostname).indexOf('localhost')) {
          return src;
        } else {
          return src.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
        }
      };

      if (category === 'シート' && spec.name === 'シート材質') {
        let directory = 'assets/cars/';
        directory = directory + compareGrade.modelName + '/';
        directory = directory + compareGrade.carId + '/';
        directory = directory + compareGrade.carTypeCode + '/';
        directory = directory + convertKataToRome(compareGrade.gradeId) + '/';
        directory = directory + 'seat/';
        return (
          <div>
            {(this.state.isMounted === true && spec.unit) ?
              <img className="CarsComparison__car-comparison-detail__seat-image"
                   src={formatSrc(getMediaDirectory() + directory + spec.unit + '.png')}/>: ''}
            {(spec.value) ?
              <p className="CarsComparison__car-comparison-detail__value">{spec.value.join(' | ')}</p>: ''}
          </div>
        )
      } else {
        return (
          <div>
            {(this.state.isMounted === true && spec.unit) ?
              <div><img className="CarsComparison__car-comparison-detail__unit-image"
                        src={formatSrc(getMediaDirectory() + 'assets/home/common/icon/' + spec.unit + '.png')}/>
              </div>: ''}
            {(spec.value) ?
              <p className="CarsComparison__car-comparison-detail__value">{spec.value.join(' | ')}</p>: ''}
          </div>
        )
      }
    };

    return (
      <div className="CarsComparison__car-comparison-detail">
        <div className="CarsComparison__car-comparison-detail__fade-in-container" ref="changeVariant">
          <div className="CarsComparison__car-comparison-detail__container">
            <div ref="spec">
              <div className="CarsComparison__car-comparison-detail__box">
                <a
                  className={'CarsComparison__car-comparison-detail__link-open' + ((this.state.openAccordion) ? ' open': '')}
                  href="javascript:void(0);"
                  onClick={(e) => {
                    e.preventDefault();
                    // アコーディオンを閉じる、開く
                    this.changeAccordionView();
                  }}
                >
                  <span className="CarsComparison__car-comparison-detail__link-open__open">すべて見る</span>
                  <span className="CarsComparison__car-comparison-detail__link-open__close">すべて閉じる</span>
                  <span className="CarsComparison__car-comparison-detail__link-open__icon"/>
                  <span className="CarsComparison__car-comparison-detail__link-open__icon2"/>
                </a>
              </div>
              {renderSpecCategory()}
            </div>
          </div>
          <ul className="CarsComparison__car-comparison-detail__list">
            <li>標準装備</li>
            <li>メーカーオプション</li>
            <li>設定無し</li>
          </ul>
        </div>
      </div>
    );
  }

  // スペック変更
  changeSpecs = () => {
    this.setState({
      openAccordion: false,
    });
    let i, max;
    for (i = 0, max = this.accordionRefs.length; i < max; i = i + 1) {
      if (i <= 0) {
        this.refs[this.accordionRefs[i]].open();
        this.refs[this.accordionRefs[i]].onResize();
      } else {
        this.refs[this.accordionRefs[i]].close();
      }
    }
    // if (this.state.openAccordion === true) {
    //   let i, max;
    //   for (i = 0, max = this.accordionRefs.length; i < max; i = i + 1) {
    //     if (i <= 0) {
    //       this.refs[this.accordionRefs[i]].open();
    //     } else {
    //       this.refs[this.accordionRefs[i]].close();
    //     }
    //   }
    //   this.setState({
    //     openAccordion: false,
    //   })
    // }
    // フェードインアニメーション
    this.refs.changeVariant.classList.remove('open');
    setTimeout(() => {
      this.refs.changeVariant.classList.add('open');
    }, 100);
  };

  // アコーディオンを閉じる、開く
  changeAccordionView = () => {
    if (this.state.openAccordion === true) {
      let i, max;
      for (i = 0, max = this.accordionRefs.length; i < max; i = i + 1) {
        this.refs[this.accordionRefs[i]].close();
      }
      this.setState({
        openAccordion: false,
      })
    } else {
      let i, max;
      for (i = 0, max = this.accordionRefs.length; i < max; i = i + 1) {
        this.refs[this.accordionRefs[i]].open();
      }
      this.setState({
        openAccordion: true,
      })
    }
  };

}



// WEBPACK FOOTER //
// ./src/containers/cars-comparison/index.jsx